
window.chai_promo_is_active = false;
window.chai_id = 11696490381356;
// Matcha tea set: Variant ID: 11971578527788
// Matcha tea: Variant ID: 11696459481132
window.chai_promo_discount_items_arr = [11971578527788, 11696459481132];



















// this object details the book pre-order //
// THESE ARE THE REAL DETAILS // window.book_pre_order = { active: true , id: 3954787745836 , variant: 29494053175340 } ;
// WE ARE USING THE GREEN TEA FOR NOW SO WE CAN TEST!! //
window.book_pre_order = {
  active: true,
  //Test Ids
  // id: 7713900298401,
  // variant: 43069263347873,
  // Live Ids
  id: 14866591252848,
  variant: 52466403869040,
  messages: {
    cannot_add_preorder_item: 'Sorry, you can\'t add a pre-order item to your cart. Pre-order items must be ordered separately from other products.',
    cannot_add_ordinary_item: 'You have a pre-order product in your cart. Please complete checkout for your pre-order, then you will be able to make a new order for this product.'
  }
};



// new preorder item: Natural Immune Health thingo
// SKU: NIS_150
// Variant id: 11672932483116
// product_id: 1198793031724
// window.book_pre_order = {
//   active: false,
//   id: 1198793031724,
//   variant: 11672932483116,

//   messages: {
//     cannot_add_preorder_item: 'Sorry, you can\'t add a pre-order item to your cart. Pre-order items must be ordered separately from other products.',
//     cannot_add_ordinary_item: 'You have a pre-order product in your cart. Please complete checkout for your pre-order, then you will be able to make a new order for this product.'
//   }
// };



/* Free Turmeric Latte Over $99 */
// console.log('Testing currency');
// console.log({{ window.currencyISO }});
if (window.stop_promo) {
  window.body_shaping_sample_promo_is_active = false;
} else {
  window.body_shaping_sample_promo_is_active = false;
}
console.log(window.body_shaping_sample_promo_is_active);
//window.body_shaping_sample_promo_is_active = true;
window.body_shaping_sample_promo_is_active = false;
window.body_shaping_sample_id = 43898098417825;
// Test Id
//window.body_shaping_sample_id = 42753212580001;


var body_shaping_sample_standard_variant_id = 43898098417825
window.body_shaping_sample_promo_discount_items_arr = []
window.body_shaping_sample_promo_discount_items_arr.push(body_shaping_sample_standard_variant_id);

/* body shaping protein discout */
window.body_shaping_book_promo_is_active = false;
window.body_shaping_book_id = 13689713721388;


//1637951602732 ;
/*
Body Shaping Protein - Vanilla - BSP_14V
 standard  variant id: 13271934631980
 bundle    variant id: 29267952140332

Body Shaping Protein - Cocoa - BSP_14C 
 standard  variant id: 13272565612588
 bundle    variant id: 29267951943724
*/

/* NEW/UPDATED Values */
var body_shaping_protein_vanilla_standard_variant_id = 13271934631980; //1558873145388
var body_shaping_protein_vanilla_bundle_variant_id = 37406808768673; // 29267952140332 ; //34977067401377

var body_shaping_protein_cocoa_standard_variant_id = 13272565612588; //1558988521516 ;
var body_shaping_protein_cocoa_bundle_variant_id = 34977067630753; //29267951943724 THIS WAS WRONG //
var body_shaping_protein_cocoa_bundle_variant_2_id = 34977067401377;
var body_shaping_protein_cocoa_bundle_variant_3_id = 37406808998049;




//window.body_shaping_book_promo_discount_items_arr = [ 13271934631980 , 29267952140332 , 13272565612588 , 29267951943724 ] ;
window.body_shaping_book_promo_discount_items_arr = []
window.body_shaping_book_promo_discount_items_arr.push(body_shaping_protein_vanilla_standard_variant_id);
window.body_shaping_book_promo_discount_items_arr.push(body_shaping_protein_vanilla_bundle_variant_id);

window.body_shaping_book_promo_discount_items_arr.push(body_shaping_protein_cocoa_standard_variant_id);
window.body_shaping_book_promo_discount_items_arr.push(body_shaping_protein_cocoa_bundle_variant_id);
window.body_shaping_book_promo_discount_items_arr.push(body_shaping_protein_cocoa_bundle_variant_2_id);
window.body_shaping_book_promo_discount_items_arr.push(body_shaping_protein_cocoa_bundle_variant_3_id);


// add an item which isn't in there for some reason //
// vanilla
//window.body_shaping_book_promo_discount_items_arr.push( 29667517759532 ) ;
// cocoa
//window.body_shaping_book_promo_discount_items_arr.push( 29667517628460 ) ;
/* end body shaping protein discout */




















// add additional promo active variable here
// add additional promo ids used here


window.theme = window.theme || {};
window.slate = window.slate || {};
window.LOGGING = false;

/* ================ SLATE ================ */
theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = _.filter(this.instances, function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  wrapTable: function () {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function () {
    var $iframeVideo = $(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'
    );
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function () {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $('a[href*=#]').on(
      'click',
      function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function () {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    src = src || '';

    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match === null) {
      return null;
    } else {
      return match[1];
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function (element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function (variant) {
        return selectedValues.every(function (values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function (variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();


/*================ MODULES ================*/
window.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('body, html'),
      $page: $('.page-element'),
      $moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);
    this.$open = $(this.config.open);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    this.$open.attr('aria-expanded', 'false');
    this.$open.on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened drawer
    if (this.drawerIsOpen) {
      return;
    }

    this.$open.addClass(this.config.openClass);

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.nodes.$moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();
  };

  Drawer.prototype.close = function () {
    // don't close a closed drawer
    if (!this.drawerIsOpen) {
      return;
    }

    this.$open.removeClass(this.config.openClass);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.nodes.$moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false');
    }

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function () {
    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function () {
      return false;
    });

    // Clicking out of drawer closes it
    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function () {
        this.close();
        return false;
      }, this)
    );

    // Pressing escape closes drawer
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function (evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function () {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();

theme.Hero = (function () {
  var selectors = {
    hero: '.hero',
    heroWrapper: '.hero-wrapper',
    heroArrows: '.hero__arrow',
    heroImage: '.hero__image',
    heroPause: '.hero__pause'
  };

  function Hero() {
    this.namespace = '.hero';
    this.$hero = $(selectors.hero);
    this.$hero.on('init' + this.namespace, this._a11y.bind(this));
    this.$hero.on('init' + this.namespace, this._arrowsInit.bind(this));

    this.$hero.slick({
      accessibility: true,
      arrows: false, // this theme has custom arrows
      dots: true,
      draggable: false,
      autoplay: this.$hero.data('autoplay'),
      autoplaySpeed: this.$hero.data('speed')
    });

    $(selectors.heroImage).on(
      'click' + this.namespace,
      function () {
        this.$hero.slick('slickNext');
      }.bind(this)
    );

    $(selectors.heroPause).on(
      'click' + this.namespace,
      function () {
        if ($(selectors.heroPause).hasClass('is-paused')) {
          this._play();
        } else {
          this._pause();
        }
      }.bind(this)
    );
  }

  Hero.prototype = _.assignIn({}, Hero.prototype, {
    _pause: function () {
      this.$hero.slick('slickPause');
      $(selectors.heroPause).addClass('is-paused');
    },

    _play: function () {
      this.$hero.slick('slickPlay');
      $(selectors.heroPause).removeClass('is-paused');
    },

    _a11y: function (event, obj) {
      var $list = obj.$list;

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused
      // pause slideshow and set aria-live
      $(selectors.heroWrapper).on(
        'focusin' + this.namespace,
        function (evt) {
          if (!$(selectors.heroWrapper).has(evt.target).length) {
            return;
          }

          $list.attr('aria-live', 'polite');
          this._pause();
        }.bind(this)
      );

      // Resume autoplay
      $(selectors.heroWrapper).on(
        'focusout' + this.namespace,
        function (evt) {
          if (!$(selectors.heroWrapper).has(evt.target).length) {
            return;
          }

          $list.removeAttr('aria-live');
          this._play();
        }.bind(this)
      );
    },

    _arrowsInit: function (event, obj) {
      // Slider is initialized. Setup custom arrows
      var count = obj.slideCount;
      var $slider = obj.$slider;
      var $arrows = $(selectors.heroArrows);

      if ($arrows.length && count > 1) {
        $arrows.on(
          'click' + this.namespace,
          function (evt) {
            evt.preventDefault();
            if ($(evt.currentTarget).hasClass('hero__arrow--prev')) {
              $slider.slick('slickPrev');
            } else {
              $slider.slick('slickNext');
            }

            this._scrollTop();
          }.bind(this)
        );
      } else {
        $arrows.remove();
      }
    },

    _scrollTop: function () {
      var currentScroll = $(document).scrollTop();
      var heroOffset = this.$hero.offset().top;

      if (currentScroll > heroOffset) {
        $('html')
          .add('body')
          .animate(
            {
              scrollTop: heroOffset
            },
            250
          );
      }
    },

    goToSlide: function (slideIndex) {
      this.$hero.slick('slickGoTo', slideIndex);
    },

    pause: function () {
      this.$hero.slick('slickPause');
    },

    play: function () {
      this.$hero.slick('slickPlay');
    },

    destroy: function () {
      this.$hero.off(this.namespace);
      $(selectors.heroImage).off(this.namespace);
      $(selectors.heroPause).off(this.namespace);
      $(selectors.heroWrapper).off(this.namespace);
      $(selectors.heroArrows).off(this.namespace);

      this.$hero.slick('unslick');
    }
  });

  return Hero;
})();

window.Modals = (function () {
  var Modal = function (id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active'
    };

    this.$modal = $('#' + id);

    if (!this.$modal.length) {
      return false;
    }

    this.nodes = {
      $body: $('body')
    };

    this.config = $.extend(defaults, options);

    this.modalIsOpen = false;
    this.$focusOnOpen = this.config.focusOnOpen
      ? $(this.config.focusOnOpen)
      : this.$modal;
    this.init();
  };

  Modal.prototype.init = function () {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr('aria-expanded', 'false');

    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$modal.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Modal.prototype.open = function (evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.modalIsOpen && !externalCall) {
      return this.close();
    }

    this.$modal.prepareTransition().addClass(this.config.openClass);
    this.nodes.$body.addClass(this.config.openClass);

    this.modalIsOpen = true;

    // Set focus on modal
    slate.a11y.trapFocus({
      $container: this.$modal,
      namespace: 'modal_focus',
      $elementToFocus: this.$focusOnOpen
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();
  };

  Modal.prototype.close = function () {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    this.$modal.prepareTransition().removeClass(this.config.openClass);
    this.nodes.$body.removeClass(this.config.openClass);

    this.modalIsOpen = false;

    // Remove focus on modal
    slate.a11y.removeTrapFocus({
      $container: this.$modal,
      namespace: 'modal_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false').focus();
    }

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function () {
    // Pressing escape closes modal
    this.nodes.$body.on(
      'keyup.modal',
      $.proxy(function (evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }, this)
    );
  };

  Modal.prototype.unbindEvents = function () {
    this.nodes.$body.off('.modal');
  };

  return Modal;
})();

window.Meganav = (function () {
  var Meganav = function (options) {
    this.cache = {
      $document: $(document),
      $page: $('.page-element')
    };

    var defaults = {
      $meganavs: $('.meganav'),
      $megaNav: $('.meganav__nav'),
      $meganavToggle: $('.meganav-toggle'),
      $meganavDropdownContainers: $('.site-nav__dropdown-container'),
      $meganavToggleThirdLevel: $('.meganav__link-toggle'),
      $meganavLinkSecondLevel: $('.meganav__link--second-level'),
      $meganavLinkThirdLevel: $('.meganav__link--third-level'),
      $meganavDropdownThirdLevel: $('.site-nav__dropdown--third-level'),
      isOpen: false,
      preventDuplicates: false,
      closeOnPageClick: false,
      closeThirdLevelOnBlur: false,
      activeClass: 'meganav--active',
      drawerClass: 'meganav--drawer',
      meganavDropdown: '.site-nav__dropdown',
      meganavLinkClass: 'meganav__link',
      drawerToggleClass: 'drawer__nav-toggle-btn',
      drawerNavItem: '.drawer__nav-item',
      navCollectionClass: 'meganav__nav--collection',
      secondLevelClass: 'meganav__link--second-level',
      thirdLevelClass: 'meganav__link-toggle',
      thirdLevelContainerClass: 'site-nav__dropdown--third-level',
      noAnimationClass: 'meganav--no-animation'
    };

    this.config = $.extend(defaults, options);
    this.init();
  };

  Meganav.prototype.init = function () {
    var $openBtn = this.config.$meganavToggle;

    $openBtn.on('click', $.proxy(this.requestMeganav, this));

    if (this.config.closeThirdLevelOnBlur) {
      this.config.$meganavLinkThirdLevel.on(
        'blur',
        $.proxy(this.closeThirdLevelMenu, this)
      );
    }
  };

  Meganav.prototype.requestMeganav = function (evt) {
    var $targetedMeganav;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    }

    // Without this, the meganav opens, the click event bubbles up to
    // theme.cache.$page which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
    }

    var $el = $(evt.currentTarget);
    var anotherNavIsOpen = this.config.isOpen;
    var isThirdLevelBtn = $el.hasClass(this.config.thirdLevelClass);

    // The $targetedMeganav is different for the drawer and non-drawer navs
    if ($el.hasClass(this.config.drawerToggleClass)) {
      $targetedMeganav = $el
        .closest(this.config.drawerNavItem)
        .children('.' + this.config.drawerClass);
    } else {
      $targetedMeganav = $el.siblings(this.config.meganavDropdown);
    }

    // Navigate to link href or close menu if already active
    if ($el.hasClass(this.config.activeClass) && $el.is('a')) {
      window.location = $el.attr('href');
      return;
    }

    // If true, don't let multiple meganavs be open simultaneously
    if (!isThirdLevelBtn && this.config.preventDuplicates) {
      this.close();
    }

    if ($targetedMeganav.hasClass(this.config.drawerClass)) {
      var isExpanded = $el.attr('aria-expanded') === 'true';

      $el
        .toggleClass(this.config.activeClass)
        .attr('aria-expanded', !isExpanded);

      $targetedMeganav.stop().slideToggle(200);
    } else {
      $el.addClass(this.config.activeClass).attr('aria-expanded', 'true');

      // Show targeted nav, letting it know whether another meganav is already open
      this.open($el, $targetedMeganav, anotherNavIsOpen);
    }

    // Setup event handlers when meganav is open
    this.bindEvents();
    this.config.isOpen = true;

    // If dropdown has third level, calculate width for container
    var $dropdown = $el.next();
    var isCollection = $dropdown
      .find(this.config.$megaNav)
      .hasClass(this.config.navCollectionClass);

    if (isCollection) {
      this.updateThirdLevelContainerWidth($el, $dropdown);
    }
  };

  Meganav.prototype.updateThirdLevelContainerWidth = function ($el, $dropdown) {
    var $thirdLevel = $dropdown.find(this.config.$meganavDropdownThirdLevel);

    if (!$thirdLevel.length) {
      return;
    }

    $.each(
      $thirdLevel,
      function (key, container) {
        var $container = $(container);
        var $lastChild = $container.find('li:last-child');

        this.updateContainerWidth($container, $lastChild);
      }.bind(this)
    );
  };

  Meganav.prototype.updateContainerWidth = function (container, element) {
    var containerRect = container[0].getBoundingClientRect();
    var elementRect = element[0].getBoundingClientRect();

    if (elementRect.left < containerRect.right) {
      return;
    }

    var columnWidth = containerRect.width;
    var containerFixedWidth =
      elementRect.left + columnWidth - containerRect.left;
    var numberOfColumns = containerFixedWidth / columnWidth;
    var containerPercentageWidth = numberOfColumns * 20;

    container
      .width(containerPercentageWidth + '%')
      .find('li')
      .css('width', 100 / numberOfColumns + '%');
  };

  Meganav.prototype.open = function ($el, $target, noAnimation) {
    var isThirdLevelBtn = $el.hasClass(this.config.thirdLevelClass);

    $target.addClass(this.config.activeClass);

    if (isThirdLevelBtn) {
      this.toggleSubNav($el, $target);
    }

    // Add class to override animation - CSS determined
    if (noAnimation) {
      $target.addClass(this.config.noAnimationClass);
    }
  };

  Meganav.prototype.toggleSubNav = function ($el) {
    this.removeMenuActiveState();

    $el
      .addClass(this.config.activeClass)
      .attr('aria-expanded', 'true')
      .siblings(this.config.$meganavDropdownThirdLevel)
      .addClass(this.config.activeClass);

    $el.parent().addClass(this.config.activeClass);
  };

  Meganav.prototype.close = function (evt, $target) {
    if (this.config.preventDuplicates) {
      // Close all meganavs
      this.config.$meganavs.removeClass(
        [this.config.activeClass, this.config.noAnimationClass].join(' ')
      );
      this.config.$meganavToggle
        .removeClass(this.config.activeClass)
        .attr('aria-expanded', 'false');

      this.config.$meganavDropdownContainers.removeClass(
        this.config.activeClass
      );
    } else {
      // Close targeted nav
      var $targetedMeganav = $('#' + $target.attr('aria-controls'));
      $targetedMeganav.removeClass(
        [this.config.activeClass, this.config.noAnimationClass].join(' ')
      );
      $target
        .removeClass(this.config.activeClass)
        .attr('aria-expanded', 'false');
    }

    // Remove event listeners
    this.unbindEvents();
    this.config.isOpen = false;
  };

  Meganav.prototype.closeThirdLevelMenu = function (evt) {
    var $el = $(evt.currentTarget);
    var $parent = $el.parent();

    if (!$parent.is(':last-child')) {
      return;
    }

    this.config.$meganavLinkSecondLevel.one(
      'focus.meganav',
      $.proxy(function () {
        this.removeMenuActiveState();
      }, this)
    );
  };

  Meganav.prototype.removeMenuActiveState = function () {
    var activeClasses = [this.config.activeClass, this.config.noAnimationClass];

    this.config.$meganavToggleThirdLevel
      .removeClass(activeClasses.join(' '))
      .attr('aria-expanded', 'false');

    this.config.$meganavDropdownThirdLevel.removeClass(activeClasses.join(' '));
    this.config.$meganavDropdownContainers.removeClass(this.config.activeClass);
  };

  Meganav.prototype.bindEvents = function () {

    if (!this.config.closeOnPageClick) {
      return;
    }

    // Clicking away from the meganav will close it
    this.cache.$page.on('click.meganav', $.proxy(this.close, this));

    // Exception to above: clicking anywhere on the meganav will NOT close it
    this.config.$meganavs.on(
      'click.meganav',
      function (evt) {
        // 3rd level container
        var is3rdLevelMenuTarget =
          $(evt.currentTarget).hasClass(this.config.activeClass) &&
          $(evt.currentTarget).hasClass(this.config.thirdLevelContainerClass);

        // 2nd level mega link
        var isMegaNavlink =
          $(evt.target).hasClass(this.config.meganavLinkClass) &&
          $(evt.target).hasClass(this.config.secondLevelClass);

        // If we click anything outside from the 3rd level megaNav, close the third level menu (except for 2nd level links)
        if (!is3rdLevelMenuTarget && !isMegaNavlink) {
          this.removeMenuActiveState();
        }

        evt.stopImmediatePropagation();

      }.bind(this)
    );

    // Pressing escape closes meganav and focuses the target parent link
    this.cache.$document.on(
      'keyup.meganav',
      $.proxy(function (evt) {
        if (evt.keyCode !== 27) return;

        this.config.$meganavToggle
          .filter('.' + this.config.activeClass)
          .focus();
        this.close();
      }, this)
    );
  };

  Meganav.prototype.unbindEvents = function () {
    if (!this.config.closeOnPageClick) {
      return;
    }

    this.cache.$page.off('.meganav');
    this.config.$meganavs.off('.meganav');
    this.cache.$document.off('.meganav');
    this.config.$meganavLinkSecondLevel.off('.meganav');
    this.config.$meganavLinkThirdLevel.off('.meganav');
  };

  return Meganav;
})();

window.QtySelector = (function () {
  var QtySelector = function ($el) {
    this.cache = {
      $body: $('body'),
      $subtotal: $('#CartSubtotal'),
      $discountTotal: $('#cartDiscountTotal'),
      $cartTable: $('.cart-table'),
      $cartTemplate: $('#CartProducts')
    };

    this.settings = {
      loadingClass: 'js-qty--is-loading',
      isCartTemplate: this.cache.$body.hasClass('template-cart'),
      // On the cart template, minimum is 0. Elsewhere min is 1
      minQty: this.cache.$body.hasClass('template-cart') ? 0 : 1
    };

    this.$el = $el;
    this.qtyUpdateTimeout;
    this.createInputs();
    this.bindEvents();
  };

  QtySelector.prototype.createInputs = function () {
    var $el = this.$el;

    var data = {
      value: $el.val(),
      key: $el.attr('id'),
      name: $el.attr('name'),
      line: $el.attr('data-line')
    };
    var source = $('#QuantityTemplate').html();
    var template = Handlebars.compile(source);

    this.$wrapper = $(template(data)).insertBefore($el);

    // Remove original number input
    $el.remove();
  };

  QtySelector.prototype.validateAvailability = function (line, quantity) {
    var product = theme.cartObject.items[line - 1]; // 0-based index in API
    var handle = product.handle; // needed for the ajax request
    var id = product.id; // needed to find right variant from ajax results

    var params = {
      type: 'GET',
      url: '/products/' + handle + '.js',
      dataType: 'json',
      success: $.proxy(function (cartProduct) {
        this.validateAvailabilityCallback(line, quantity, id, cartProduct);
      }, this)
    };

    $.ajax(params);
  };

  QtySelector.prototype.validateAvailabilityCallback = function (
    line,
    quantity,
    id,
    product
  ) {
    var quantityIsAvailable = true;

    // This returns all variants of a product.
    // Loop through them to get our desired one.
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      if (variant.id === id) {
        break;
      }
    }

    // If the variant tracks inventory and does not sell when sold out
    // we can compare the requested with available quantity
    if (
      variant.inventory_management !== null &&
      variant.inventory_policy === 'deny'
    ) {
      if (variant.inventory_quantity < quantity) {
        // Show notification with error message
        theme.Notify.open('error', theme.strings.noStockAvailable, true);

        // Set quantity to max amount available
        this.$wrapper.find('.js-qty__input').val(variant.inventory_quantity);

        quantityIsAvailable = false;
        this.$wrapper.removeClass(this.settings.loadingClass);
      }
    }

    if (quantityIsAvailable) {
      this.updateItemQuantity(line, quantity);
    }
  };

  QtySelector.prototype.validateQty = function (qty) {
    if (parseFloat(qty) === parseInt(qty, 10) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return parseInt(qty, 10);
  };

  QtySelector.prototype.adjustQty = function (evt) {
    var $el = $(evt.currentTarget);
    var $input = $el.siblings('.js-qty__input');
    var qty = this.validateQty($input.val());
    var line = $input.attr('data-line');

    if ($el.hasClass('js-qty__adjust--minus')) {
      qty -= 1;
      if (qty <= this.settings.minQty) {
        qty = this.settings.minQty;
      }
    } else {
      qty += 1;
    }

    if (this.settings.isCartTemplate) {
      $el.parent().addClass(this.settings.loadingClass);
      this.updateCartItemPrice(line, qty);
    } else {
      $input.val(qty);
      $('.update-shopping-cart.btn--secondary.update-cart').trigger("click");
    }
  };

  QtySelector.prototype.bindEvents = function () {
    this.$wrapper
      .find('.js-qty__adjust')
      .on('click', $.proxy(this.adjustQty, this));

    // Select input text on click
    this.$wrapper.on('click', '.js-qty__input', function () {
      this.setSelectionRange(0, this.value.length);
    });

    // If the quantity changes on the cart template, update the price
    if (this.settings.isCartTemplate) {
      this.$wrapper.on(
        'change',
        '.js-qty__input',
        $.proxy(function (evt) {
          var $input = $(evt.currentTarget);
          var line = $input.attr('data-line');
          var qty = this.validateQty($input.val());
          $input.parent().addClass(this.settings.loadingClass);
          this.updateCartItemPrice(line, qty);
        }, this)
      );
    }
  };

  QtySelector.prototype.updateCartItemPrice = function (line, qty) {
    // Update cart after short timeout so user doesn't create simultaneous ajax calls
    clearTimeout(this.qtyUpdateTimeout);
    this.qtyUpdateTimeout = setTimeout(
      $.proxy(function () {
        this.validateAvailability(line, qty);
      }, this),
      200
    );
  };

  QtySelector.prototype.updateItemQuantity = function (line, quantity) {
    var params = {
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      success: $.proxy(function (cart) {
        this.updateCartItemCallback(cart);
      }, this)
    };

    $.ajax(params);
  };

  QtySelector.prototype.updateCartItemCallback = function (cart) {
    // Reload the page to show the empty cart if no items
    if (cart.item_count === 0) {
      location.reload();
      return;
    }

    // Update cart object
    theme.cartObject = cart;

    // Handlebars.js cart layout
    var data = {};
    var items = [];
    var item = {};
    var source = $('#CartProductTemplate').html();
    var template = Handlebars.compile(source);
    var prodImg;

    // Add each item to our handlebars.js data
    $.each(cart.items, function (index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add 240x240, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */

      if (cartItem.image === null) {
        prodImg =
          '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
      } else {
        prodImg = cartItem.image
          .replace(/(\.[^.]*)$/, '_240x240$1')
          .replace('http:', '');
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function (key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
        });
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemQty: cartItem.quantity,
        price: theme.Currency.formatMoney(cartItem.price, theme.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: theme.Currency.formatMoney(
          cartItem.line_price,
          theme.moneyFormat
        ),
        originalLinePrice: theme.Currency.formatMoney(
          cartItem.original_line_price,
          theme.moneyFormat
        ),
        discounts: cartItem.discounts,
        discountsApplied:
          cartItem.line_price === cartItem.original_line_price ? false : true
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items
    };
    this.cache.$cartTemplate.empty().append(template(data));

    // Create new quantity selectors
    this.cache.$cartTable.find('input[type="number"]').each(function (i, el) {
      new QtySelector($(el));
    });

    // Update the cart subtotal
    console.log('!!!!!!Update the cart subtotal');
    this.cache.$subtotal.html(
      theme.Currency.formatMoney(cart.total_price, theme.moneyFormat)
    );

    // Update the cart total discounts
    if (cart.total_discount > 0) {
      this.cache.$discountTotal.html(
        theme.strings.totalCartDiscount.replace(
          '[savings]',
          theme.Currency.formatMoney(cart.total_discount, theme.moneyFormat)
        )
      );
    } else {
      this.cache.$discountTotal.empty();
    }

    // Set focus on cart table
    slate.a11y.pageLinkFocus(this.cache.$cartTable);

    document.location.reload();
  };

  return QtySelector;
})();

/*
  Allow product to be added to cart via ajax with
  custom success and error responses.
*/
window.AjaxCart = (function () {
  var cart = function ($form) {
    this.cache = {
      $cartIconIndicator: $('.site-header__cart-indicator')
    };

    this.$form = $form;
    this.eventListeners();
  };

  cart.prototype.eventListeners = function () {
    if (this.$form.length) {
      this.$form.on('submit', $.proxy(this.addItemFromForm, this));
    }
  };







  cart.prototype.addItemFromForm = function (evt) {


    evt.preventDefault();

    /*
    .  Is pre-order active?
    .   - No
    .      > FOLLOW NORMAL ADD TO CART PROCEDURE
    .   - Yes
    .      > Are there already items in the cart?
    .        - No
    .            > FOLLOW NORMAL ADD TO CART PROCEDURE
    .        - Yes
    .          > Is the new item a pre-order item?
    .            - No
    .              > Are there any pre-order items in the cart already? 
    .                - No
    .                  > FOLLOW NORMAL ADD TO CART PROCEDURE
    .                - Yes
    .                  > DO NOT ADD TO CART, instead NOTIFY the user that they must check out their pre-order items before adding a non-pre-order items to their cart
    .            - Yes
    .              > Are there ONLY pre-order items in the cart already?
    .                - No
    .                  > DO NOT ADD TO CART, instead NOTIFY the user that they must check out their non-pre-order items before adding a pre-order to their cart
    .                - Yes
    .                  > FOLLOW NORMAL ADD TO CART PROCEDURE (no need to notify the user again)
    */

    // if the book preorder is active, run the logic //
    if (!window.book_pre_order.active) {


      console.log('addToCartFrom form this = ', this);

      // ajr devnote: this is the original code before adding in anything related to the book pre-order //
      //console.log( 'this.$form.serialize(): ' , this.$form.serialize() ) ;
      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: this.$form.serialize(),
        dataType: 'json',
        success: $.proxy(function (lineItem) {
          this.success(lineItem);
        }, this),
        error: $.proxy(function (XMLHttpRequest, textStatus) {
          this.error(XMLHttpRequest, textStatus);
        }, this)
      };

      $.ajax(params);





      // If we're using the pre-order logic... //
    } else if (window.book_pre_order.active) {

      var serialized = this.$form.serialize();
      window.last_serialized = serialized;

      var product_id_and_more = serialized.split('id=');
      var product_id = product_id_and_more[1].split('&')[0];
      var attempting_to_add_pre_order_item = false;
      if (product_id == window.book_pre_order.id || product_id == window.book_pre_order.variant) attempting_to_add_pre_order_item = true;


      // wait for all the ajax stuff to happen //
      new Promise((resolve, reject) => {


        // retrieve the cart json before we do anything else so we can check if the book pre-order is going to be acceptable //
        $.get('/cart.js', function (data) {

          console.log('data:', data);
          if (typeof data == 'string') data = JSON.parse(data);

          //console.log( "Cart load was performed." , data ) ;

          var pre_order_item_is_already_in_cart = 0;
          var cart_has_items = false;
          var cart_items_length = 0;
          if (data.items) {
            pre_order_item_is_already_in_cart = checkCartForBookPreOrderItem(data.items);
            cart_has_items = true;
            cart_items_length = data.items.length;
          }


          console.log('Adding an item to cart via form, and the book pre-order is active');
          console.log('product_id (within the cart load): ', product_id);

          // confirm the status of pre_order_item_is_already_in_cart 
          console.log('pre_order_item_is_already_in_cart: ', pre_order_item_is_already_in_cart);

          // let us know if the product the customer has asked to add is actually the pre-order book //
          console.log('attempting_to_add_pre_order_item: ', attempting_to_add_pre_order_item);

          // if there are any items in the cart already, we have to evaluate them and the item being added //
          if (cart_items_length > 0) {

            // check if the user is trying to add the preorder item when there's already other products in the cart //
            if (attempting_to_add_pre_order_item) {

              // if there are already items in the cart, that may be ok, so long as there are only pre-order items in the cart //
              console.log('pre_order_item_is_already_in_cart: ', pre_order_item_is_already_in_cart)
              console.log('data.items.length: ', data.items.length);
              console.log('comparison: ', (data.items.length > pre_order_item_is_already_in_cart));

              var non_pre_order_items_in_cart = (pre_order_item_is_already_in_cart < data.items.length);

              if (non_pre_order_items_in_cart) {
                //'Sorry, you can\'t add a pre-order item to your cart. Pre-order items must be ordered separately from other products.'
                reject(new Error(window.book_pre_order.messages.cannot_add_preorder_item));
              } else {
                resolve(true);
              }

            } else {


              if (pre_order_item_is_already_in_cart) {

                // already have a pre-order item in cart, so can't add anything else EXCEPT the same pre-order product //
                console.log('already have a pre-order item in cart, so can\'t add anything else EXCEPT the same pre-order product');

                //'You have a pre-order product in your cart. Please complete checkout for your pre-order product first, then you will be able to make a new order for this product.'
                reject(new Error(window.book_pre_order.messages.cannot_add_ordinary_item));

              } else {

                // this is not a pre-order item, and there are no pre-order items in the cart, so add the product to cart as per usual //
                console.log('this is not a pre-order item, and there are no pre-order items in the cart, so add the product to cart as per usual');
                resolve(true);

              }

            }

            // if there are NO items in the cart yet, we can follow the standard approach //
          } else {

            console.log('there are NO items in the cart yet, so we just add the item to cart');
            resolve(true);
          }

        }, 'text').done(

          function () { console.log('done!'); }

        ).fail(

          function (request, error) {
            console.log('failed!', error);
            resolve(true);
          }

        );


      }).then(() => {

        console.log('promise was resolved');

        // the add to cart function to call if requirements are met //

        var params = {
          type: 'POST',
          url: '/cart/add.js',
          data: serialized,
          dataType: 'json',
          success: $.proxy(function (lineItem) {
            this.success(lineItem);
          }, this),
          error: $.proxy(function (XMLHttpRequest, textStatus) {
            this.error(XMLHttpRequest, textStatus);
          }, this)
        };
        $.ajax(params);


      }).catch((err) => {

        if (err) {
          console.log('promise was rejected');
          theme.Notify.open('error', err.message, false);
          //alert( err.message ) ;
        }

      });


    }

  };









  cart.prototype.success = function (lineItem) {

    //console.log( 'cart success!' );
    // call the update on the bold bundles to update the cart if there are bundles //
    // but ONLY DO THIS IF THE USER IS NOT A WHOLESALER //
    if ($('.not-wholesaler').length > 0) {

      console.log('because this is not a wholesale user, we update bundles and wait to hear back.');
      runHardCodedPromotions(lineItem).then(function () {

        console.log('hard coded promotions');

        window.shappify_pb_main(function () {

          console.log('Updated cart, so updating bold bundles.');
          // give it a delay to let the bundle change happen //
          var event = new CustomEvent('CART_UPDATED', { detail: {} });
          window.dispatchEvent(event);

        });

      });


    } else {

      var event = new CustomEvent('CART_UPDATED', { detail: {} });
      window.dispatchEvent(event);

    }




    theme.Notify.open('success', false, true);

    // Update cart notification bubble's state //
    try {
      this.cache.$cartIconIndicator.removeClass('hide');
    } catch (err) {
      console.log(err);
      $('.site-header__cart-indicator').removeClass('hide');
    }


  };
















  // Error handling reference from Shopify.onError in api.jquery.js
  cart.prototype.error = function (XMLHttpRequest) {
    var data = JSON.parse(XMLHttpRequest.responseText);

    if (data.message) {
      theme.Notify.open('error', data.description, true);
    }
  };

  return cart;
})();

window.Notify = (function () {
  var notify = function () {
    this.cache = {
      $scrollParent: $('html').add('body'),
      $notificationSuccess: $('#NotificationSuccess'),
      $notificationSuccessLink: $('#NotificationSuccess').find('a'),
      $notificationError: $('#NotificationError'),
      $notificationPromo: $('#NotificationPromo'),
      $notificationClose: $('.notification__close'),
      $notificationErrorMessage: $('.notification__message--error')
    };

    this.settings = {
      notifyActiveClass: 'notification--active',
      closeTimer: 999999999,
      promoKeyName: 'promo-' + this.cache.$notificationPromo.data('text')
    };

    this.notifyTimer;
    this.$lastFocusedElement = null;

    this.isLocalStorageSupported = isLocalStorageSupported();

    this.cache.$notificationClose.on('click', this.close.bind(this));
    this.showPromo();
  };

  function isLocalStorageSupported() {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    try {
      var storage = window.sessionStorage;
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }



  notify.prototype.open = function (state, message, autoclose) {
    this.close();

    var spinner_is_showing = $('#cart-reveal.loading').length;
    if (!spinner_is_showing) {
      var event = new CustomEvent('CART_UPDATED', { detail: {} });
      window.dispatchEvent(event);
    }




    if (state === 'success') {

      this.cache.$notificationSuccess
        .attr('aria-hidden', false)
        .addClass(this.settings.notifyActiveClass);

      // Set last focused element to return to once success
      // notification is dismissed (by timeout)
      this.$lastFocusedElement = $(document.activeElement);

      // Set focus on link to cart after transition
      this.cache.$notificationSuccess.one(
        'TransitionEnd webkitTransitionEnd transitionend oTransitionEnd',
        $.proxy(function () {
          slate.a11y.pageLinkFocus(this.cache.$notificationSuccessLink);
        }, this)
      );

      // Fallback for no transitions
      if (this.cache.$scrollParent.hasClass('no-csstransitions')) {
        slate.a11y.pageLinkFocus(this.cache.$notificationSuccessLink);
      }
    } else {
      this.cache.$notificationErrorMessage.html(message);
      this.cache.$notificationError
        .attr('aria-hidden', false)
        .addClass(this.settings.notifyActiveClass);
    }

    // Timeout to close the notification
    if (autoclose) {
      clearTimeout(this.notifyTimer);
      this.notifyTimer = setTimeout(
        this.close.bind(this),
        this.settings.closeTimer
      );
    }
  };

  notify.prototype.close = function (evt) {
    if (evt && $(evt.currentTarget).attr('id') === 'NotificationPromoClose') {
      if (this.isLocalStorageSupported) {
        localStorage.setItem(this.settings.promoKeyName, 'hidden');
      }
    }

    // Return focus to previous element if one is defined
    // and the user has not strayed from the success notification link

    // Removed by Signifi to avoid slamming the page down after adding an item to cart //
    /*
    if (
      this.$lastFocusedElement &&
      this.cache.$notificationSuccessLink.is(':focus')
    ) {
      slate.a11y.pageLinkFocus(this.$lastFocusedElement);
    }*/

    // Close all notification bars
    this.cache.$notificationSuccess
      .attr('aria-hidden', true)
      .removeClass(this.settings.notifyActiveClass);
    this.cache.$notificationError
      .attr('aria-hidden', true)
      .removeClass(this.settings.notifyActiveClass);
    this.cache.$notificationPromo
      .attr('aria-hidden', true)
      .removeClass(this.settings.notifyActiveClass);

    // Reset last focused element
    this.$lastFocusedElement = null;
  };

  notify.prototype.showPromo = function (SFEevent) {
    // If reloaded in the storefront editor, update selectors/settings
    if (SFEevent) {
      this.initCache();
    }

    if (
      this.isLocalStorageSupported &&
      localStorage[this.settings.promoKeyName] === 'hidden'
    ) {
      return;
    }

    this.cache.$notificationPromo
      .attr('aria-hidden', false)
      .addClass(this.settings.notifyActiveClass);
  };

  return notify;
})();

theme.Maps = (function () {
  var config = {
    zoom: 14,
    styles: [
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ color: '#cacaca' }, { lightness: 17 }]
      },
      {
        featureType: 'landscape',
        elementType: 'geometry',
        stylers: [{ color: '#e1e1e1' }, { lightness: 20 }]
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.fill',
        stylers: [{ color: '#ffffff' }, { lightness: 17 }]
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#ffffff' }, { lightness: 29 }, { weight: 0.2 }]
      },
      {
        featureType: 'road.arterial',
        elementType: 'geometry',
        stylers: [{ color: '#ffffff' }, { lightness: 18 }]
      },
      {
        featureType: 'road.local',
        elementType: 'geometry',
        stylers: [{ color: '#ffffff' }, { lightness: 16 }]
      },
      {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{ color: '#e1e1e1' }, { lightness: 21 }]
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{ color: '#bbbbbb' }, { lightness: 21 }]
      },
      {
        elementType: 'labels.text.stroke',
        stylers: [{ visibility: 'on' }, { color: '#ffffff' }, { lightness: 16 }]
      },
      {
        elementType: 'labels.text.fill',
        stylers: [{ saturation: 36 }, { color: '#333333' }, { lightness: 40 }]
      },
      { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
      {
        featureType: 'transit',
        elementType: 'geometry',
        stylers: [{ color: '#f2f2f2' }, { lightness: 19 }]
      },
      {
        featureType: 'administrative',
        elementType: 'geometry.fill',
        stylers: [{ color: '#fefefe' }, { lightness: 20 }]
      },
      {
        featureType: 'administrative',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#fefefe' }, { lightness: 17 }, { weight: 1.2 }]
      }
    ] // eslint-disable-line key-spacing, comma-spacing
  };
  var apiStatus = null;
  var mapsToLoad = [];

  function Map(container) {
    theme.$currentMapContainer = this.$container = $(container);
    var key = this.$container.data('api-key');

    if (typeof key !== 'string' || key === '') {
      return;
    }

    if (apiStatus === 'loaded') {
      var self = this;

      // Check if the script has previously been loaded with this key
      var $script = $('script[src*="' + key + '&"]');
      if ($script.length === 0) {
        $.getScript(
          'https://maps.googleapis.com/maps/api/js?key=' + key
        ).then(function () {
          apiStatus = 'loaded';
          self.createMap();
        });
      } else {
        this.createMap();
      }
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + key
          ).then(function () {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function (index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function (results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function () {
      var $map = this.$container.find('.map-section__container');

      return geolocate($map)
        .then(
          function (results) {
            var mapOptions = {
              zoom: config.zoom,
              styles: config.styles,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());
            var enablePin = $map.data('enable-pin');

            var markerColor = $map.data('marker-color');

            var markerIcon = {
              path:
                'M57.7,0C25.8,0,0,25.8,0,57.7C0,89.5,50,170,57.7,170s57.7-80.5,57.7-112.3C115.3,25.8,89.5,0,57.7,0z M57.7,85 c-14.9,0-27-12.1-27-27c0-14.9,12.1-27,27-27c14.9,0,27,12.1,27,27C84.7,72.9,72.6,85,57.7,85z',
              fillColor: markerColor,
              fillOpacity: 0.9,
              scale: 0.2,
              strokeWeight: 0
            };

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: center,
              icon: markerIcon,
              visible: enablePin
            });

            google.maps.event.addDomListener(
              window,
              'resize',
              $.debounce(250, function () {
                google.maps.event.trigger(map, 'resize');
                map.setCenter(center);
              })
            );
          }.bind(this)
        )
        .fail(function () {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = theme.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break;
          }

          // Only show error in the theme editor
          if (Shopify.designMode) {
            var $mapContainer = $map.parents('.map-section');

            $mapContainer.addClass('page-width map-section--load-error');
            $mapContainer.find('.map-section__content-wrapper').remove();
            $mapContainer
              .find('.map-section__wrapper')
              .html(
                '<div class="errors text-center" style="width: 100%;">' +
                errorMessage +
                '</div>'
              );
          }
        });
    },

    onUnload: function () {
      if (typeof window.google !== 'undefined') {
        google.maps.event.clearListeners(this.map, 'resize');
      }
    }
  });

  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  if (!Shopify.designMode) return;

  theme.$currentMapContainer.addClass('page-width map-section--load-error');
  theme.$currentMapContainer.find('.map-section__content-wrapper').remove();
  theme.$currentMapContainer
    .find('.map-section__wrapper')
    .html(
      '<div class="errors text-center" style="width: 100%;">' +
      theme.strings.authError +
      '</div>'
    );
}

theme.stickyHeader = (function () {
  var selectors = {
    searchCartWrapper: '#SiteNavSearchCart',
    stickyNavSearchCart: '#StickyNavSearchCart',
    stickyNavWrapper: '#StickNavWrapper',
    stickyBar: '#StickyBar'
  };

  var config = {
    lastScroll: 0,
    navClass: 'sticky--active',
    openTransitionClass: 'sticky--open',
    closeTransitionClass: 'sticky--close'
  };

  var cache = {};

  function cacheSelectors() {
    cache = {
      $window: $(window),
      $siteNavSearchCart: $(selectors.searchCartWrapper),
      $stickyBar: $(selectors.stickyBar)
    };
  }

  function init() {
    cacheSelectors();
    config.isActive = false;

    // Clone search/cart icons into fixed nav
    if (cache.$siteNavSearchCart.contents().length) {
      cache.$siteNavSearchCart
        .contents()
        .clone()
        .appendTo($(selectors.stickyNavSearchCart));
    }

    // devnote: this was throwing an error before - if to prevent that //
    if ($.throttle) {
      cache.$window.on('scroll.stickynav', $.throttle(15, stickyHeaderOnScroll));
    }
  }

  function stickyHeaderOnScroll() {

    // This is not the cause of the unwanted scrolling //
    var scroll = cache.$window.scrollTop();
    var $el = $(selectors.stickyNavWrapper);
    var threshold = $el.offset().top + $el.height() + 10; // default for scrolling down

    // Check if scrolling up
    if (scroll < config.lastScroll) {
      threshold = $el.offset().top;
    }

    if (scroll > threshold) {
      stickNav();
    } else {
      unstickNav();
    }

    config.lastScroll = scroll;

  }

  function stickNav() {
    if (config.isActive) {
      return;
    }

    config.isActive = true;

    cache.$stickyBar.addClass(config.navClass);

    // Add open transition class after element is set to fixed
    // so CSS animation is applied correctly
    setTimeout(function () {
      cache.$stickyBar.addClass(config.openTransitionClass);
    }, 0);
  }

  function unstickNav() {
    if (!config.isActive) {
      return;
    }

    cache.$stickyBar
      .removeClass(config.openTransitionClass)
      .removeClass(config.navClass);

    config.isActive = false;
  }

  function unload() {
    $(window).off('.stickynav');
  }

  return {
    init: init,
    unload: unload
  };
})();

theme.headerNav = (function () {
  var selectors = {
    siteNav: '#SiteNav',
    siteNavCompressed: '#SiteNavCompressed',
    siteNavParent: '#SiteNavParent',
    siteNavItem: '.site-nav__item',
    stickyNavWrapper: '#StickNavWrapper',
    stickyNav: '#StickyNav'
  };

  var config = {
    lastScroll: 0,
    isActive: false,
    navClass: 'sticky--active',
    openTransitionClass: 'sticky--open',
    closeTransitionClass: 'sticky--close',
    searchShowClass: 'site-header__search-input--visible',
    searchInputClass: 'site-header__search-input',
    searchSubmitClass: 'site-header__search-submit',
    searchInnerActiveClass: 'search-header__search-inner--active'
  };

  function init() {
    sizeNav();
    initMegaNavs();
    initHeaderSearch();

    // devnote: was causing error, if to prevent //
    if ($.debounce) {
      $(window).on('resize.headernav', $.debounce(250, sizeNav));
    }

  }

  function sizeNav() {
    var navWidth = 0;
    var parentWidth = $(selectors.siteNavParent).width();
    var hideClass = 'hide';

    // Set height on nav-bar wrapper so when fixed, doesn't break layout
    $(selectors.stickyNavWrapper).height($(selectors.stickyNav).height());

    // Calculate the width of each nav item
    // after forcing them to be visible for the calculations
    $(selectors.siteNav).removeClass(hideClass);
    $(selectors.siteNavItem).each(function (i, el) {
      navWidth += $(el).width();
    });

    if (navWidth > parentWidth) {
      $(selectors.siteNav).addClass(hideClass);
      $(selectors.siteNavCompressed).removeClass(hideClass);
    } else {
      $(selectors.siteNav).removeClass(hideClass);
      $(selectors.siteNavCompressed).addClass(hideClass);
    }
  }

  function initMegaNavs() {
    new window.Meganav({
      $meganavs: $('.site-nav__dropdown'),
      $meganavToggle: $('.site-nav__link-toggle'),
      preventDuplicates: true,
      closeOnPageClick: true,
      closeThirdLevelOnBlur: true
    });

    // new window.Meganav({
    //   $meganavs: $('.site-nav__dropdown--regular'),
    //   $meganav: $('.meganav__nav--regular'),
    //   $meganavToggle: $('.nav__link-regular-toggle'),
    //   preventDuplicates: true,
    //   closeOnPageClick: true,
    //   closeThirdLevelOnBlur: true
    // });

    new window.Meganav({
      $meganavs: $('.meganav--index'),
      $meganavToggle: $('.index__meganav-toggle')
    });

    new window.Meganav({
      $meganavs: $('.meganav--drawer'),
      $meganavToggle: $('.drawer__meganav-toggle')
    });
  }

  function initHeaderSearch() {
    // This function runs after the header search element
    // is duplicated into the sticky nav, meaning there are
    // two search fields to be aware of at this point.
    var $searchForm = $('.site-header__search');

    $searchForm.each(function (i, el) {
      var $form = $(el);
      var $input = $form.find('.' + config.searchInputClass);
      var $submit = $form.find('.' + config.searchSubmitClass);
      var $searchInner = $('.site-header__search-inner');

      $input.on('focus', function () {
        $searchInner.addClass(config.searchInnerActiveClass);
        $input.addClass(config.searchShowClass);
      });

      $input.on('blur', function () {
        $searchInner.removeClass(config.searchInnerActiveClass);
        if ($input.val()) {
          $input.addClass(config.searchShowClass);
        } else {
          $input.removeClass(config.searchShowClass);
        }
      });

      $submit.on('click', function (evt) {
        if ($input.hasClass(config.searchShowClass)) {
          return;
        }

        evt.preventDefault();
        $input.addClass(config.searchShowClass).focus();
      });
    });
  }

  function unload() {
    $(window).off('.stickynav');
  }

  return {
    init: init,
    unload: unload
  };
})();


/*================ TEMPLATES ================*/
theme.customerTemplates = (function () {
  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function (evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function (evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    // check if reset password form was successfully submited
    if (!$('.reset-password-success').length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function () {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function () {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function () {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function () {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink('/account/addresses/' + formId, {
          parameters: { _method: 'delete' }
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function () {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();


/*================ SECTIONS ================*/
theme.HeaderSection = (function () {
  function Header() {
    theme.stickyHeader.init();
    theme.headerNav.init();
    theme.Notify = new window.Notify();
    theme.NavDrawer = new window.Drawers('NavDrawer', 'left');
    drawerSearch();
  }

  function drawerSearch() {
    var $drawerSearch = $('.drawer__search-input');
    var $drawerSearchSubmit = $('.drawer__search-submit');

    $drawerSearchSubmit.on('click', function (evt) {
      if ($drawerSearch.val().length !== 0) {
        return;
      }

      evt.preventDefault();
      $drawerSearch.focus();
    });
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function () {
      theme.stickyHeader.unload();
      theme.headerNav.unload();
    }
  });

  return Header;
})();

theme.Filters = (function () {
  var selectors = {
    filterSelection: '#SortTags',
    sortSelection: '#SortBy'
  };

  function Filters() {
    this.$filterSelect = $(selectors.filterSelection);
    this.$sortSelect = $(selectors.sortSelection);

    this.default = this._getDefaultSortValue();
    this.$sortSelect.val(this.default);

    this.$filterSelect.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _getDefaultSortValue: function () {
      return Shopify.queryParams.sort_by
        ? Shopify.queryParams.sort_by
        : this.$sortSelect.data('default-sort');
    },

    _onFilterChange: function () {
      delete Shopify.queryParams.page;

      console.log('Val: ' + this.$filterSelect.val());
      //alert( 'Params: ' + $.param(Shopify.queryParams) ) ;

      if ($.isEmptyObject(Shopify.queryParams)) {
        location.href = this.$filterSelect.val();
      } else {
        location.href =
          this.$filterSelect.val() + '?' + $.param(Shopify.queryParams);
      }
    },

    _onSortChange: function () {
      Shopify.queryParams.sort_by = this.$sortSelect.val();
      location.search = $.param(Shopify.queryParams);
    },

    onUnload: function () {
      this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return Filters;
})();

theme.Product = (function () {
  var defaults = {
    smallBreakpoint: 750, // copied from variables.scss
    productThumbIndex: 0,
    productThumbMax: 0,
    ajaxCart: false,
    stockSetting: false
  };

  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.selectors = {
      originalSelectorId: '#ProductSelect-' + sectionId,
      modal: 'ProductModal',
      productZoomImage: '#ProductZoomImg',
      addToCart: '#AddToCart-' + sectionId,
      productPrice: '#ProductPrice-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      SKU: '.variant-sku',
      productFeaturedImage: '#ProductPhotoImg-' + sectionId,
      productImageWrap: '#ProductPhotoLink-' + sectionId,
      productThumbAllImages: '.product-single__thumbnail',
      productThumbImages: '.product-single__thumbnail-' + sectionId,
      productThumbs: '#ProductThumbs-' + sectionId,
      saleTag: '#ProductSaleTag-' + sectionId,
      productStock: '#ProductStock-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button'
    };

    this.settings = $.extend({}, defaults, {
      sectionId: sectionId,
      ajaxCart: $container.data('ajax'),
      stockSetting: $container.data('stock'),
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.product-' + sectionId,
      imageSize: theme.Images.imageSize(
        $(this.selectors.productFeaturedImage).attr('src')
      )
    });

    // Stop parsing if we don't have the product json script tag
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      $('#ProductJson-' + sectionId).html()
    );
    this.addVariantInfo();

    this.init();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    init: function () {
      this._stringOverrides();
      this._initVariants();
      this._productZoomImage();
      // this._productThumbSwitch();
      this._productThumbnailSlider();
      this._initQtySelector();

      if (this.settings.ajaxCart) {
        theme.AjaxCart = new window.AjaxCart(
          $('#AddToCartForm-' + this.settings.sectionId)
        );
      }

      // Pre-loading product images to avoid a lag when a thumbnail is clicked, or
      // when a variant is selected that has a variant image.
      // theme.Images.preload(
      //   this.productSingleObject.images,
      //   this.settings.imageSize
      // ); 
    },

    _stringOverrides: function () {
      window.productStrings = window.productStrings || {};
      $.extend(theme.strings, window.productStrings);
    },

    addVariantInfo: function () {
      if (!this.productSingleObject || !this.settings.stockSetting) {
        return;
      }

      var variantInfo = JSON.parse(
        $('#VariantJson-' + this.settings.sectionId).html()
      );

      for (var i = 0; i < variantInfo.length; i++) {
        $.extend(this.productSingleObject.variants[i], variantInfo[i]);
      }
    },

    _initVariants: function () {
      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        product: this.productSingleObject,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId
      };

      // eslint-disable-next-line no-new
      this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAddToCartBtn.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
    },

    _updateStock: function (variant) {
      if (!this.settings.stockSetting) return;

      var $stock = $(this.selectors.productStock);

      // If we don't track variant inventory, hide stock
      if (!variant || !variant.inventory_management) {
        $stock.addClass('hide');
        return;
      }

      if (variant.inventory_quantity < 10 && variant.inventory_quantity > 0) {
        $stock
          .html(
            theme.strings.stockAvailable.replace(
              '1',
              variant.inventory_quantity
            )
          )
          .removeClass('hide');
        return;
      }

      if (variant.inventory_quantity <= 0 && variant.incoming) {
        $stock
          .html(
            theme.strings.willNotShipUntil.replace(
              '[date]',
              variant.next_incoming_date
            )
          )
          .removeClass('hide');
        return;
      }

      // If there's more than 10 available, hide stock
      $stock.addClass('hide');
    },

    _updateIncomingInfo: function (variant) {
      if (!this.settings.stockSetting) return;

      var $stock = $(this.selectors.productStock);

      if (variant.incoming) {
        $stock
          .html(
            theme.strings.willBeInStockAfter.replace(
              '[date]',
              variant.next_incoming_date
            )
          )
          .removeClass('hide');
        return;
      }

      // If there is no stock incoming, hide stock
      $stock.addClass('hide');
    },

    _updateAddToCartBtn: function (evt) {
      var variant = evt.variant;

      var cache = {
        $addToCart: $(this.selectors.addToCart),
        $addToCartText: $(this.selectors.addToCartText)
      };

      if (variant) {
        // Select a valid variant if available
        if (variant.available) {
          // We have a valid product variant, so enable the submit button
          cache.$addToCart.removeClass('btn--sold-out').prop('disabled', false);
          cache.$addToCartText.html(theme.strings.addToCart);
          $(this.selectors.shopifyPaymentButton, this.$container).show();
          // Show how many items are left, if below 10
          this._updateStock(variant);
        } else {
          // Variant is sold out, disable the submit button
          cache.$addToCart.prop('disabled', true).addClass('btn--sold-out');
          cache.$addToCartText.html(theme.strings.soldOut);
          $(this.selectors.shopifyPaymentButton, this.$container).hide();
          // Update when stock will be available
          this._updateIncomingInfo(variant);
        }
      } else {
        cache.$addToCart.prop('disabled', true).removeClass('btn--sold-out');
        cache.$addToCartText.html(theme.strings.unavailable);
        $(this.selectors.shopifyPaymentButton, this.$container).hide();
        // Hide stock display
        this._updateStock();
      }
    },

    _updatePrice: function (evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.productPrice).html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );

        // Update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          $(this.selectors.comparePrice)
            .html(
              theme.Currency.formatMoney(
                variant.compare_at_price,
                theme.moneyFormat
              )
            )
            .removeClass('hide');
          $(this.selectors.saleTag).removeClass('hide');
        } else {
          $(this.selectors.comparePrice).addClass('hide');
          $(this.selectors.saleTag).addClass('hide');
        }
      } else {
        $(this.selectors.comparePrice).addClass('hide');
      }


      console.log('price changed!');
      // ajr 20190314
      //signifi_update_afterpay();

    },

    _updateSKU: function (evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.SKU).html(variant.sku);
      }
    },

    _updateImages: function (evt) {
      var variant = evt.variant;

      if (variant && variant.featured_image) {
        var sizedImgUrl = theme.Images.getSizedImageUrl(
          variant.featured_image.src,
          this.settings.imageSize
        );
        var largeImgUrl = theme.Images.getSizedImageUrl(
          variant.featured_image.src,
          '1024x1024'
        );
        this.switchProductImage(sizedImgUrl, largeImgUrl);
        this.setActiveThumbnail();
      }
    },

    switchProductImage: function (image, largeImage) {
      $(this.selectors.productFeaturedImage).attr('src', image);
      $(this.selectors.productImageWrap).attr('href', largeImage);
    },

    setActiveThumbnail: function ($el) {
      var $thumbnails = $(this.selectors.productThumbs);

      // If there is no element passed, find it by the current product image
      if (typeof $el === 'undefined') {
        var src = $(this.selectors.productFeaturedImage).attr('src');
        $el = $('.product-single__thumbnail[href="' + src + '"]');

      }

      // Set active thumbnail class
      $thumbnails
        .find('.product-single__thumbnail-item')
        .removeClass('is-active');
      $el.parent().addClass('is-active');

      // If there is a slick carousel, get the slide index, and position it into view with animation.
      if ($thumbnails.hasClass('slick-initialized')) {
        // eslint-disable-next-line shopify/jquery-dollar-sign-reference
        var currentActiveSlideIndex = $thumbnails.slick('slickCurrentSlide');
        var newActiveSlideIndex = $el.parent().attr('data-slick-index');
        if (currentActiveSlideIndex !== newActiveSlideIndex) {
          $thumbnails.slick('slickGoTo', newActiveSlideIndex, false);
        }
      }
    },

    _productZoomImage: function () {
      /*if (!$(this.selectors.productFeaturedImage).length) {
        return;
      }

      var self = this;

      $(this.selectors.productImageWrap).on(
        'click' + this.settings.namespace,
        function(evt) {
          evt.preventDefault();
          // Empty src before loadig new image to avoid awkward image swap
          $(self.selectors.productZoomImage)
            .attr('src', '')
            .attr('src', $(this).attr('href'));
        }
      );

      this.ProductModal = new window.Modals(
        this.selectors.modal,
        'product-modal'
      );

      // Close modal if clicked, but not if the image is clicked
      this.ProductModal.$modal.on('click' + this.settings.namespace, function(
        evt
      ) {
        if (evt.target.nodeName !== 'IMG') {
          self.ProductModal.close();
        }
      });*/

    },

    _productThumbSwitch: function () {
      if (!$(this.selectors.productThumbs).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages).on(
        'click' + this.settings.namespace,
        function (evt) {
          evt.preventDefault();
          var $el = $(this);
          var sizedImageUrl = $el.attr('href');
          var largeImageUrl = $el.attr('data-zoom');
          self.setActiveThumbnail($el);
          self.switchProductImage(sizedImageUrl, largeImageUrl);
        }
      );
    },

    /*
      Thumbnail slider
     */
    _productThumbnailSlider: function () {
      var $productThumbWrapper = $(this.selectors.productThumbs);
      if (!$productThumbWrapper.length) {
        return;
      }

      var thumbnailCount = $productThumbWrapper.find(
        this.selectors.productThumbAllImages
      ).length;

      if (thumbnailCount > 1) {
        $productThumbWrapper.on(
          'init' + this.settings.namespace,
          this._productSwipeInit.bind(this)
        );

        var nextArrow;
        var prevArrow;
        var sliderArrows = window.sliderArrows || false;

        // sliderArrows is an object defined in product.liquid to set custom
        // SVG arrow icons.
        if (sliderArrows) {
          nextArrow =
            '<button type="button" class="slick-next"><span>' +
            sliderArrows.right +
            '</span><span class="hide">' +
            sliderArrows.down +
            '</span></button>';
          prevArrow =
            '<button type="button" class="slick-prev"><span>' +
            sliderArrows.left +
            '</span><span class="hide">' +
            sliderArrows.up +
            '</span></button>';
        }

        $productThumbWrapper.slick({
          accessibility: false,
          arrows: false,
          dots: true,
          infinite: false,
          autoplay: true,
          autoplaySpeed: 10000,
          speed: 2000,
          pauseOnFocus: true,
          pauseOnHover: true,

          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
          nextArrow: nextArrow,
          prevArrow: prevArrow,
          responsive: [
            {
              breakpoint: this.settings.smallBreakpoint,
              settings: {
                vertical: false,
                verticalSwiping: false
              }
            }
          ]
        });

        // Show highlighted thumbnail by repositioning slider
        $productThumbWrapper.slick(
          'slickGoTo',
          $productThumbWrapper.find('.is-active').attr('data-slick-index'),
          true
        );

        var initSlide = $productThumbWrapper.find('.slick-active').find('img');
        $(initSlide).elevateZoom({
          zoomType: "inner",
          cursor: "crosshair"
          //, zoomWindowWidth: 1000
          //, zoomWindowHeight: 1000
          //, lensFadeIn: 500 
          , zoomWindowFadeIn: 500
          , zoomWindowFadeOut: 500
          //, touchEnabled: false
        });

        $productThumbWrapper.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          var currentSlide = $(slick.$slides[currentSlide]);
          var nextSlide = $(slick.$slides[nextSlide]);
          // currentSlide.find('img').remove();
          $.removeData(currentSlide.find('img'), 'elevateZoom');
          $('.zoomContainer').remove();// remove zoom container from DOM
          nextSlide.find('img').elevateZoom({
            zoomType: "inner",
            cursor: "crosshair"
            , zoomWindowFadeIn: 500
            , zoomWindowFadeOut: 500
            //, touchEnabled: false
          });
        });
      }
    },

    _productSwipeInit: function (evt, obj) {
      // Slider is initialized. Setup custom swipe events
      this.settings.productThumbIndex = obj.currentSlide;
      this.settings.productThumbMax = obj.slideCount - 1; // we need the 0-based index

      $(this.selectors.productFeaturedImage).on(
        'swipeleft swiperight',
        function (event) {
          if (event.type === 'swipeleft') {
            this._goToNextThumbnail();
          }

          if (event.type === 'swiperight') {
            this._goToPrevThumbnail();
          }

          // Trigger click on newly requested thumbnail
          $(
            '.product-single__thumbnail-item[data-slick-index="' +
            this.settings.productThumbIndex +
            '"]'
          )
            .find('.product-single__thumbnail')
            .trigger('click');
        }
      );
    },

    _goToNextThumbnail: function () {
      this.settings.productThumbIndex++;

      if (this.settings.productThumbIndex > this.settings.productThumbMax) {
        this.settings.productThumbIndex = 0;
      }

      $(this.selectors.productThumbs).slick(
        'slickGoTo',
        this.settings.productThumbIndex,
        true
      );

    },

    _goToPrevThumbnail: function () {
      this.settings.productThumbIndex--;

      if (this.settings.productThumbIndex < 0) {
        this.settings.productThumbIndex = this.settings.productThumbMax;
      }

      $(this.selectors.productThumbs).slick(
        'slickGoTo',
        this.settings.productThumbIndex,
        true
      );
    },

    _initQtySelector: function () {
      this.$container.find('.product-form__quantity').each(function (i, el) {
        // eslint-disable-next-line no-new
        new QtySelector($(el));
      });
    },

    onUnload: function () {
      $(this.selectors.productImageWrap).off(this.settings.namespace);
      $(this.selectors.productThumbImages).off(this.settings.namespace);
      $(this.selectors.productThumbs).slick('unslick');
      this.ProductModal.$modal.off(this.settings.namespace);
    }
  });

  return Product;
})();

theme.Slideshow = (function () {
  function Slideshow() {
    // remove videos on mobile
    console.log(' *** window.keep_videos_on_mobile:', window.keep_videos_on_mobile);
    if (document.body.clientWidth < 500) {
      console.log('Removing video?');
      if (!window.keep_videos_on_mobile) {
        $(".vimeo-homepage-wrapper").parent().parent().remove();
      } else {
        console.log('DO NOT REMOVE VIDEO');
      }

    }  /* -- */

    this.slideshow = new theme.Hero();
    // Dev TODO remove this line to restore autoplay //
    //this.slideshow.pause();
    // devnote 20200108 - removed because client wants the slideshow to autoplay again now //
  }

  Slideshow.prototype = _.assignIn({}, Slideshow.prototype, {
    onUnload: function () {
      this.slideshow.destroy();
    },

    onSelect: function () {
      this.slideshow.pause();
    },

    onDeselect: function () {
      this.slideshow.play();
    },

    onBlockSelect: function (evt) {
      var $slide = $(
        '.hero__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      this.slideshow.pause();
      this.slideshow.goToSlide(slideIndex);
    },

    onBlockDeselect: function () {
      this.slideshow.play();
    }
  });
  return Slideshow;
})();

theme.Cart = (function () {
  var selectors = {
    cartNote: '#CartSpecialInstructions',
    cartQtyInput: '.cart__quantity',
    cartNoCookiesClass: 'cart--no-cookies'
  };

  function Cart(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    theme.cartObject = JSON.parse($('#CartJson-' + sectionId).html());

    this.init($container);
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    init: function ($container) {
      this._initQtySelector();
      this._initCartNote();

      if (!this._cookiesEnabled()) {
        $container.addClass(selectors.cartNoCookiesClass);
      }
    },

    _initQtySelector: function () {
      $(selectors.cartQtyInput).each(function (i, el) {
        // eslint-disable-next-line no-new
        new QtySelector($(el));
      });
    },

    _initCartNote: function () {
      if (!$(selectors.cartNote).length) {
        return;
      }

      var $el = $(selectors.cartNote);
      var noteText;
      var params;
      var noteOffset = $el[0].offsetHeight - $el[0].clientHeight;

      // Auto grow the cart note if text fills it up
      $el.on('keyup input', function () {
        $(this)
          .css('height', 'auto')
          .css('height', $el[0].scrollHeight + noteOffset);
      });

      // Save the cart note via ajax. A safeguard in case
      // a user decides to leave the page before clicking 'Update Cart'
      $el.on(
        'change',
        $.proxy(function () {
          noteText = $el.val();
          params = {
            type: 'POST',
            url: '/cart/update.js',
            data: 'note=' + this._attributeToString(noteText),
            dataType: 'json'
          };
          $.ajax(params);
        }, this)
      );
    },

    _attributeToString: function (attr) {
      if (typeof attr !== 'string') {
        attr = String(attr);
        if (attr === 'undefined') {
          attr = '';
        }
      }
      return $.trim(attr);
    },

    _cookiesEnabled: function () {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();

theme.Quotes = (function () {
  function Quotes(container) {

    /*console.log( 'QUOTES' , container , container.outerHTML ) 
    console.log( container ) ;*/

    this.$container = $(container).on('init', this._a11y.bind(this));

    this.$container.slick({
      accessibility: true,
      arrows: true,
      dots: false,
      draggable: true,
      autoplay: false
    });
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    _a11y: function (event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container.parent();

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },

    _goToSlide: function (slideIndex) {
      this.$container.slick('slickGoTo', slideIndex);
    },

    onUnload: function () {
      delete this.$container;
    },

    onBlockSelect: function (evt) {
      // Ignore the cloned version
      var $slide = $(
        '.quote__slide-wrapper--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      this._goToSlide(slideIndex);
    }
  });

  return Quotes;
})();


theme.Publishers = (function () {
  function Publishers(container) {

    console.log('Publishers', container); // , this , this.innerHTML

    this.$container = $(container).on('init', this._a11y.bind(this));

    this.$container.slick({
      accessibility: true,
      arrows: true,
      dots: false,
      draggable: true,
      autoplay: true
    });
  }

  Publishers.prototype = _.assignIn({}, Publishers.prototype, {
    _a11y: function (event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container.parent();

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },

    _goToSlide: function (slideIndex) {
      this.$container.slick('slickGoTo', slideIndex);
    },

    onUnload: function () {
      delete this.$container;
    },

    onBlockSelect: function (evt) {
      // Ignore the cloned version
      var $slide = $(
        '.publisher__slide-wrapper--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');



      // Go to selected slide, pause autoplay
      this._goToSlide(slideIndex);
    }
  });

  return Publishers;

})();


theme.Products = (function () {
  function Products(container) {
    this.$container = $(container).on('init', this._a11y.bind(this));

    this.$container.slick({
      accessibility: true,
      arrows: true,
      dots: false,
      draggable: true,
      autoplay: false,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 1960,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
  }

  Products.prototype = _.assignIn({}, Products.prototype, {
    _a11y: function (event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container.parent();

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },

    _goToSlide: function (slideIndex) {
      this.$container.slick('slickGoTo', slideIndex);
    },

    onUnload: function () {
      delete this.$container;
    },

    onBlockSelect: function (evt) {
      // Ignore the cloned version
      var $slide = $(
        '.product__slide-wrapper--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      this._goToSlide(slideIndex);
    }
  });

  return Products;
})();

theme.Video = (function () {
  var promiseYoutubeAPI;
  var promiseVimeoAPI;

  var youtube = {
    promiseAPI: function () {
      if (!promiseYoutubeAPI) {
        var tag = document.createElement('script');

        tag.src = 'https://www.youtube.com/iframe_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        promiseYoutubeAPI = $.Deferred(function (defer) {
          window.onYouTubeIframeAPIReady = defer.resolve;

          setTimeout(function () {
            defer.reject('Request for YouTube API timed out after 30 seconds.');
          }, 30000);
        });
      }

      return promiseYoutubeAPI;
    },
    promisePlayer: function (id, options) {
      return this.promiseAPI().then(function () {
        return $.Deferred(function (defer) {
          if (typeof window.YT === 'undefined') {
            defer.reject(
              "We're sorry, something went wrong. The YouTube API has not loaded correctly."
            );
          }

          /* eslint-disable no-undef */
          var player = new YT.Player(id, options); // global YT variable injected by YouTube API

          player.addEventListener('onReady', function () {
            defer.resolve(player);
          });

          setTimeout(function () {
            defer.reject(
              'Request for YouTube player has timed out after 30 seconds.'
            );
          }, 30000);
        });
      });
    }
  };

  var vimeo = {
    promiseAPI: function () {
      if (!promiseVimeoAPI) {
        promiseVimeoAPI = $.Deferred(function (defer) {
          var tag = document.createElement('script');
          tag.src = 'https://player.vimeo.com/api/player.js';
          tag.onload = tag.onreadystatechange = function () {
            if (!this.readyState || this.readyState === 'complete') {
              defer.resolve();
            }
          };

          var firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

          setTimeout(function () {
            defer.reject('Request for Vimeo API timed out after 30 seconds.');
          }, 30000);
        });
      }

      return promiseVimeoAPI;
    },

    promisePlayer: function (id, options) {
      return this.promiseAPI().then(function () {
        return $.Deferred(function (defer) {
          if (typeof window.Vimeo === 'undefined') {
            defer.reject(
              "We're sorry, something went wrong. The Vimeo API has not loaded correctly."
            );
          }

          var player = new window.Vimeo.Player(id, options);

          setTimeout(function () {
            defer.reject(
              'Request for Vimeo player has timed out after 30 seconds.'
            );
          }, 30000);

          player.ready().then(function () {
            defer.resolve(player);
          });
        });
      });
    }
  };

  var selectors = {
    loadPlayerButton: '.video-section__load-player-button',
    closePlayerButton: '.video-section__player-close',
    playerContainer: '.video-section__player',
    cover: '.video-section__cover',
    errorMessage: '.video-section__error',
    bodyOverlay: '.video-section__body-overlay',
    body: 'body'
  };
  var classes = {
    playerLoading: 'video-section--loading',
    playerLoaded: 'video-section--loaded',
    playerError: 'video-section--error',
    videoPlaying: 'video-playing'
  };

  function Video(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');
    this.namespace = '.' + sectionId;
    this.onLoad();
  }

  Video.prototype = _.assignIn({}, Video.prototype, {
    onLoad: function () {
      this.$container
        .on('click', selectors.loadPlayerButton, this._loadPlayer.bind(this))
        .on('click', selectors.closePlayerButton, this._closePlayer.bind(this))
        .on('click', selectors.bodyOverlay, this._closePlayer.bind(this));
    },

    _loadPlayer: function () {
      var $container = this.$container;
      var $playerContainer = $(selectors.playerContainer, $container);
      var playerType = this.$container.attr('data-video-type');

      var promiseVideoPlayer;

      if (playerType === 'youtube') {
        promiseVideoPlayer = this._loadYoutubePlayer($playerContainer[0]);
      } else if (playerType === 'vimeo') {
        promiseVideoPlayer = this._loadVimeoPlayer($playerContainer[0]);
      }

      return promiseVideoPlayer
        .then(this._onPlayerLoadReady.bind(this))
        .fail(this._onPlayerLoadError.bind(this));
    },

    _loadYoutubePlayer: function (container) {
      return youtube
        .promisePlayer(container, {
          videoId: this.$container.attr('data-video-id'),
          ratio: 16 / 9,
          playerVars: {
            modestbranding: 1,
            autoplay: 1,
            showinfo: 0,
            rel: 0
          }
        })
        .then(
          function (player) {
            this.player = player;
          }.bind(this)
        );
    },

    _loadVimeoPlayer: function (container) {
      return vimeo
        .promisePlayer(container, {
          id: this.$container.attr('data-video-id')
        })
        .then(
          function (player) {
            this.player = player;
            this.player.play();
          }.bind(this)
        );
    },

    _onPlayerLoadReady: function () {
      $(selectors.closePlayerButton, this.$container)
        .show()
        .focus();
      $(selectors.cover, this.$container).addClass(classes.playerLoaded);
      this.$container.addClass(classes.playerLoaded);

      this._setScrollPositionValues();

      $(selectors.body).addClass(classes.videoPlaying);

      $(document).on('keyup' + this.namespace, this._closeOnEscape.bind(this));
      $(window).on(
        'resize' + this.namespace,
        this._setScrollPositionValues.bind(this)
      );
      slate.a11y.trapFocus({
        $container: this.$container,
        namespace: this.namespace
      });
    },

    _onPlayerLoadError: function (err) {
      this.$container.addClass(classes.playerError);
      $(selectors.errorMessage, this.$container).text(err);
    },

    _closeOnEscape: function (evt) {
      if (evt.keyCode !== 27) {
        return;
      }

      this._closePlayer();
      $(selectors.loadPlayerButton, this.$container).focus();
    },

    _onScroll: function () {
      var scrollTop = $(window).scrollTop();

      if (
        scrollTop > this.videoTop + 0.25 * this.videoHeight ||
        scrollTop + this.windowHeight <
        this.videoBottom - 0.25 * this.videoHeight
      ) {
        // Debounce DOM edits to the next frame with requestAnimationFrame
        requestAnimationFrame(this._closePlayer.bind(this));
      }
    },

    _setScrollPositionValues: function () {
      this.videoHeight = this.$container.outerHeight(true);
      this.videoTop = this.$container.offset().top;
      this.videoBottom = this.videoTop + this.videoHeight;
      this.windowHeight = $(window).innerHeight();
    },

    _closePlayer: function () {
      $(selectors.body).removeClass(classes.videoPlaying);
      $(selectors.cover, this.$container).removeClass(classes.playerLoaded);
      this.$container.removeClass(classes.playerLoaded);
      $(selectors.closePlayerButton, this.$container).hide();

      slate.a11y.removeTrapFocus({
        $container: this.$container,
        namespace: this.namespace
      });

      if (typeof this.player.destroy === 'function') {
        this.player.destroy();
      } else if (typeof this.player.unload === 'function') {
        this.player.unload();
      }

      $(document).off(this.namespace);
      $(window).off(this.namespace);
    }
  });

  return Video;
})();

theme.CollectionsList = (function () {
  function CollectionsList(container) {
    var $container = (this.$container = $(container));
    var stretchImage = $container.is('[data-stretch-image]');

    // Early return if 'secondary image layout' is enabled
    if (stretchImage) return;

    var namespace = (this.namespace = '.' + $container.attr('data-section-id'));
    var self = this;

    self._collectionListFix();
    $(window).on(
      'resize' + namespace,
      $.debounce(250, function () {
        self._collectionListFix();
      })
    );
  }

  CollectionsList.prototype = _.assignIn({}, CollectionsList.prototype, {
    onUnload: function () {
      $(window).off(this.namespace);
    },

    _collectionListFix: function () {
      var numberRows = this.$container.find('.grid').data('number-rows');
      var $featureCards = this.$container.find('.featured-card');

      // We can exit if 'Use secondary image layout' is enabled
      if ($featureCards.is('[data-stretch-image]')) return;

      // Go through each of the rows
      for (var i = 0; i < numberRows; i++) {
        var maxWrapperHeight = 0;
        var maxHeaderHeight = 0;
        var $currentRow = $featureCards.filter(
          "[data-row-number='" + (i + 1) + "']"
        );
        var $cardHeaders = $currentRow.find('.featured-card__header');

        // Find the max heights for each row
        $currentRow.each(function () {
          var $cardTitle = $(this).find('.featured-card__title');
          var $cardAction = $(this).find('.featured-card__action');
          var $cardImageWrapper = $(this).find('.featured-card__image-wrapper');
          var headerHeight =
            $cardTitle.outerHeight() + $cardAction.outerHeight() + 65;
          var wrapperHeight = $cardImageWrapper.outerHeight();
          if (headerHeight > maxHeaderHeight) {
            maxHeaderHeight = headerHeight;
          }
          if (wrapperHeight > maxWrapperHeight) {
            maxWrapperHeight = wrapperHeight;
          }
        });

        // Set the heights of the headers and cards for this row with padding
        $cardHeaders.outerHeight(maxHeaderHeight);
        $currentRow.height(maxWrapperHeight + maxHeaderHeight + 40);
      }
    }
  });

  return CollectionsList;
})();


theme.init = function () {
  theme.customerTemplates.init();
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function (evt) {
    evt.preventDefault();
  });

  // Sections
  var sections = new theme.Sections();
  sections.register('header', theme.HeaderSection);
  sections.register('product', theme.Product);
  sections.register('featured-product', theme.Product);
  sections.register('collection-filters', theme.Filters);
  sections.register('map', theme.Maps);
  sections.register('slideshow', theme.Slideshow);
  sections.register('cart', theme.Cart);
  sections.register('quotes', theme.Quotes);
  sections.register('publishers', theme.Publishers);
  sections.register('featured-products', theme.Products);
  sections.register('video', theme.Video);
  sections.register('collections-list', theme.CollectionsList);

  // Standalone modules
  $(window).on('load', theme.articleImages);
  theme.passwordModalInit();
};

theme.articleImages = function () {
  var $indentedRteImages = $('.rte--indented-images');
  if (!$indentedRteImages.length) {
    return;
  }

  $indentedRteImages.find('img').each(function (i, el) {
    var $el = $(el);
    var attr = $el.attr('style');

    // Check if undefined or float: none
    if (!attr || attr === 'float: none;') {
      // Add class to parent paragraph tag if image is wider than container
      if ($el.width() >= $indentedRteImages.width()) {
        $el.parent('p').addClass('rte__image-indent');
      }
    }
  });
};

theme.passwordModalInit = function () {
  var $loginModal = $('#LoginModal');
  if (!$loginModal.length) {
    return;
  }

  // Initialize modal
  theme.PasswordModal = new window.Modals('LoginModal', 'login-modal', {
    focusOnOpen: '#Password'
  });

  // Open modal if errors exist
  if ($loginModal.find('.errors').length) {
    theme.PasswordModal.open();
  }
};

$(theme.init);




function scrollToTopOfPage() {
  setTimeout(function () {
    //console.log( 'SCROLL UP!!' ) ;
    $("html, body").animate({ scrollTop: 0 }, "slow");
  }, 500);
}



// See https://customfields.zendesk.com/hc/en-us/articles/360000919672
jQuery(document).ready(function () {



  // add toggle functionality to cart preview //
  jQuery('#cart-reveal .trigger, .site-header__link.site-header__cart').click(function (e) {
    e.preventDefault();
    jQuery('#cart-reveal').toggleClass('opened');
    scrollToTopOfPage();
  });


  // all cart links except the close cart button //
  jQuery('a[href="/cart"]:not(.close-cart):not(.site-header__link.site-header__cart)').click(function (e) {
    e.preventDefault();
    jQuery('#cart-reveal').addClass('opened');
    scrollToTopOfPage();
  });

  // close cart button //
  jQuery('a[href="/cart"].close-cart').click(function (e) {
    e.preventDefault();
    jQuery('#cart-reveal').removeClass('opened');
  });

  addClickListenersToCartChangingLinks();


  // Close the panel and remove all classes when called.
  function close_accordion_section() {
    jQuery('#custom-fields-accordion .accordion-section').removeClass('active');
    jQuery('#custom-fields-accordion .accordion-section-title').removeClass('active');
    jQuery('#custom-fields-accordion .accordion-section-content').slideUp(300).removeClass('open');
  }

  jQuery('.accordion-section-title').click(function (e) {
    // Store the clicked link
    var currentAttrValue = jQuery(this).attr('href');

    // If open when clicked, close it.
    if (jQuery(e.target).is('.active')) {
      close_accordion_section();
    }
    else {
      // If closed, clear all classes.
      close_accordion_section();
      // Add active class to section title
      jQuery(this).addClass('active');
      // Open up the hidden content panel
      jQuery('#custom-fields-accordion ' + currentAttrValue).slideDown(300).addClass('open');
    }

    // Add an active classs to the whole wrapper. Not used by default,
    // but added for convenience.
    jQuery(this).closest('.accordion-section').addClass('active');

    // Don't try to follow the link.
    e.preventDefault();
  });
});








function handleCartChangeRequest(url) {
  //console.log( 'Cart changed...' ) ;
  //+ '&cb=' + Math.random()
  $.get(url, function (data) {

    if (LOGGING) console.log('success:', data);
    //console.log( 'success! updating cart preview' ) ;
    var event = new CustomEvent('CART_UPDATED', { detail: { origin: 'change link' } });
    window.dispatchEvent(event);


  }).fail(function () {

    //console.log( 'handleCartUpdated > failed' ) ;
    var event = new CustomEvent('CART_UPDATED', { detail: {} });
    window.dispatchEvent(event);

  });

}





function showCartLoadingSpinner() {
  //console.log( 'showing loading spinner...' ) ;
  jQuery('#cart-reveal').addClass('loading');
}

function hideCartLoadingSpinner() {
  console.log('hiding loading spinner...');
  jQuery('#cart-reveal').removeClass('loading');
}









function runHardCodedPromotions(lineItem) {

  console.log('runHardCodedPromotions...', lineItem);

  return new Promise(function (resolve, reject) {

    console.log('runHardCodedPromotions', lineItem);

    // add additional promo declination calls here //
    // wrap this if in an if with an || to allow for multiple promos and then have to catch the mulitple promises //

    if (window.chai_promo_is_active) {



      console.log('chai_promo_is_active: ', window.chai_promo_is_active);
      enableDeclineChaiPromo();
      updateForBuyXGetYPromotion(lineItem).then(function () {
        resolve(true);
      });




    } else if (window.body_shaping_book_promo_is_active) {
      console.log('body_shaping_book_promo_is_active: ', window.body_shaping_book_promo_is_active);
      enableDeclineBodyShapingBookPromo();

      updateForBuyXGetYPromotion(lineItem).then(function () {
        resolve(true);
      });

    } else if (window.body_shaping_sample_promo_is_active) {
      console.log('give me something');
      console.log('body_shaping_sample_promo_is_active: ', window.body_shaping_sample_promo_is_active);
      enableDeclineBodyShapingSamplePromo();

      updateForBuyXGetYPromotion(lineItem).then(function () {
        resolve(true);
      });

    } else {

      console.log('!body_shaping_book_promo_is_active: ', window.body_shaping_book_promo_is_active);
      resolve(true);

    }

  });


}












function updateForBuyXGetYPromotion(lineItem) {

  console.log('updateForBuyXGetYPromotion...');

  return new Promise(function (resolve, reject) {

    $.get('/cart.js', function (data) {

      var chai_tally = 0;
      var body_shaping_book_tally = 0;
      var body_shaping_sample_tally = 0;
      var promo_declined;

      //$( ".result" ).html( data );
      data = JSON.parse(data);
      console.log("Load was performed.", data);



      /* 
        First check to see if there's an active promotion
        then count how many items in the user's cart match up with discount items 
        also check if the user has previously declined this promotion
      */


      // check for chai promo 
      if (window.chai_promo_is_active) {

        for (var i = 0; i < data.items.length; i++) {
          if (data.items[i].variant_id == chai_id) {
            console.log('body shaping book found at ' + i);
            chai_tally++;
          }
        }
        //resolve( true ) ;

        console.log('chai_tally: ', chai_tally);
        promo_declined = signifiGetCookie("chai_promo_declined");
        if (promo_declined == "true") console.log('The chai latte promo has been declined');


        // check for body shaping protien book promo
      } else if (window.body_shaping_book_promo_is_active) {




        for (var i = 0; i < data.items.length; i++) {
          if (data.items[i].variant_id == body_shaping_book_id) {
            console.log('body shaping book found at ' + i);
            body_shaping_book_tally++;
          }
        }

        console.log('body_shaping_book_tally: ', body_shaping_book_tally);
        promo_declined = signifiGetCookie("body_shaping_book_promo_declined");
        if (promo_declined == "true") console.log('The body shaping book promo has been declined');




      } else if (window.body_shaping_sample_promo_is_active) {


        console.log('body_shaping_sample_promo_is_active');

        for (var i = 0; i < data.items.length; i++) {
          if (data.items[i].variant_id == body_shaping_sample_id) {
            console.log('body shaping sample found at ' + i);
            body_shaping_sample_tally++;
          }
        }

        console.log('body_shaping_sample_tally: ', body_shaping_sample_tally);
        promo_declined = signifiGetCookie("body_shaping_sample_promo_declined");
        if (promo_declined == "true") console.log('The body shaping book promo has been declined');




      }







      //resolve( true ) ;



      // only proceed if the promo has not been previously declined //
      // note we use the string, 'true' because it's coming from a cookie //
      if (promo_declined != "true") {

        var add_promo_item = false;
        var minimum_buy_quantity_for_promo_to_kick_in = 1;
        var minimum_buy_vaule_for_promo_to_kick_in = 1;
        var promo_item_already_in_cart = false;
        var items_in_cart_which_match_promo_items = 0;


        if (window.chai_promo_is_active) {


          for (var i = 0; i < data.items.length; i++) {

            var curr_id = data.items[i].variant_id;
            for (var j = 0; j < chai_promo_discount_items_arr.length; j++) {

              var curr_discount_item = chai_promo_discount_items_arr[j];
              // increase matching items if this id matches, and increase the total by the quantity of items in this line item //
              if (curr_id == curr_discount_item) items_in_cart_which_match_promo_items += data.items[i].quantity;
            }

            if (data.items[i].variant_id == chai_id) {
              console.log('chai found at ' + i);
              chai_tally++;
            }

            // add in additional promo checks here //
          }



        } else if (window.body_shaping_book_promo_is_active) {

          // increase to 2 min items //
          minimum_buy_quantity_for_promo_to_kick_in = 2;

          // loop through the items in the cart, checking to see if any match the ids of the variants of the items applicable to the discount //
          for (var i = 0; i < data.items.length; i++) {

            var curr_id = data.items[i].variant_id;
            for (var j = 0; j < body_shaping_book_promo_discount_items_arr.length; j++) {

              var curr_discount_item = body_shaping_book_promo_discount_items_arr[j];
              // increase matching items if this id matches, and increase the total by the quantity of items in this line item //
              if (curr_id == curr_discount_item) items_in_cart_which_match_promo_items += data.items[i].quantity;
            }

            if (data.items[i].variant_id == body_shaping_book_id) {
              console.log('body shaping book found at ' + i);
              body_shaping_book_tally++;
            }

            // add in additional promo checks here //
          }

        } else if (window.body_shaping_sample_promo_is_active) {

          // increase to 1 min item //
          //minimum_buy_quantity_for_promo_to_kick_in = 1;
          console.log('Total vaule is ');
          console.log(data.total_price);
          // if there is any item in the cart, run the promo also check the cart total $150
          if (data.items.length > 0 && data.total_price >= 15000) {
            console.log('body shaping sample is runging ');
            items_in_cart_which_match_promo_items = true;
            // loop through the items in the cart, checking to see if any match the ids of the variants of the items applicable to the discount //
            for (var i = 0; i < data.items.length; i++) {
              var curr_id = data.items[i].variant_id;
              if (data.items[i].variant_id == body_shaping_sample_id) {
                console.log('body shaping sample found at ' + i);
                console.log('items_in_cart_which_match_promo_items', items_in_cart_which_match_promo_items);
                body_shaping_sample_tally++;
                console.log('body_shaping_sample_tally: ', body_shaping_sample_tally);
              }
              // // increase matching items if this id matches, and increase the total by the quantity of items in this line item //
              // console.log('items_in_cart_which_match_promo_items', items_in_cart_which_match_promo_items);
              // if (curr_id == body_shaping_sample_standard_variant_id)
              //   items_in_cart_which_match_promo_items += data.items[i].quantity;
              // if (data.items[i].variant_id == body_shaping_sample_id) {
              //   console.log('body shaping sample found at ' + i);
              //   console.log('items_in_cart_which_match_promo_items', items_in_cart_which_match_promo_items);
              //   body_shaping_sample_tally++;
              //   console.log('body_shaping_sample_tally: ', body_shaping_sample_tally);
              // }

              // add in additional promo checks here //
            }
          }

        }











        //window.body_shaping_book_promo_discount_items_arr
        //if ( chai_tally > 0 ) promo_item_already_in_cart = true ;
        /*
        // if there are the exact number of items required to trigger the free item being added, 
        // just add it because we don't care if the same item's already in the cart
        if ( data.item_count == minimum_buy_quantity_for_promo_to_kick_in ) {
          console.log( 'there are the exact number of items required to trigger the free item being added, so add it because we don\'t care if the same item\'s already in the cart' ) ;
        } else if ( data.item_count > minimum_buy_quantity_for_promo_to_kick_in && promo_item_already_in_cart == false ) {
          // if there are more than the minimum number of items required to trigger the promo, 
          // AND the promo item isn't in the cart yet, then we better add it
          console.log( 'there are more than the minimum number of items required to trigger the promo, AND the promo item isn\'t in the cart yet, then we better add it' ) ;
        } else {
          // either there aren't enough items in the cart or there are but the user already has the promo item in their cart, 
          // so leave it alone //
        }*/




        console.log('body_shaping_sample_tally: ', body_shaping_sample_tally);
        console.log('window.body_shaping_sample_promo_is_active', window.body_shaping_sample_promo_is_active);

        if (window.chai_promo_is_active) {

          if (chai_tally > 0) promo_item_already_in_cart = true;

        } else if (window.body_shaping_book_promo_is_active) {

          if (body_shaping_book_tally > 0) promo_item_already_in_cart = true;

        } else if (window.body_shaping_sample_promo_is_active) {
          console.log('Sample is active ');
          if (body_shaping_sample_tally > 0) promo_item_already_in_cart = true;
          console.log('items should already in the cart ', promo_item_already_in_cart);

        }



        console.log('promo reward is already in cart? 123 ', promo_item_already_in_cart);
        console.log('minimum_buy_quantity_for_promo_to_kick_in', minimum_buy_quantity_for_promo_to_kick_in);



        if (items_in_cart_which_match_promo_items >= minimum_buy_quantity_for_promo_to_kick_in && promo_item_already_in_cart == false) add_promo_item = true;
        if (items_in_cart_which_match_promo_items && promo_item_already_in_cart == false) add_promo_item = true;
        console.log('items_in_cart_which_match_promo_items ', items_in_cart_which_match_promo_items);
        console.log('add_promo_item ', add_promo_item);
        console.log('why can not i have a console log here 1232312');
        // var add_promo_item = 'true';

        if (add_promo_item) {

          console.log('promo requirements met');

          if (window.chai_promo_is_active) {

            var params = {
              type: 'POST',
              url: '/cart/add.js',
              data: { "id": chai_id, "quantity": 1 },
              dataType: 'json',
              success: function (data) { console.log('Success!', data); },
              error: function (err) { console.log('error!', err); }
            };
            $.ajax(params);


            //console.log( 'Adding chai latte which will be free after discount is applied at checkout' ) ;
            // add the free chai //

          } else if (window.body_shaping_book_promo_is_active) {

            var params = {
              type: 'POST',
              url: '/cart/add.js',
              data: { "id": body_shaping_book_id, "quantity": 1 },
              dataType: 'json',
              success: function (data) { console.log('Success!', data); },
              error: function (err) { console.log('error!', err); }
            };
            $.ajax(params);
            console.log('Adding free Body Shaping Book which will be free after discount is applied at checkout');
            // add the free body shaping protein bag //

          }

          else if (window.body_shaping_sample_promo_is_active) {
            console.log('Start adding promo sample');
            var params = {
              type: 'POST',
              url: '/cart/add.js',
              data: { "id": body_shaping_sample_id, "quantity": 1 },
              dataType: 'json',
              success: function (data) { console.log('Success!', data); },
              error: function (err) { console.log('error!', err); }
            };
            $.ajax(params);
            console.log('Adding free Body Shaping sample which will be free after discount is applied at checkout');
            // add the free body shaping protein bag //
            var add_promo_item = true;
            // setTimeout(function () { document.location.reload() }, 2000);
            ;
            // console.log('Start adding promo sample');


            // var params = {
            //   type: 'POST',
            //   url: '/cart/add.js',
            //   data: { "id": body_shaping_sample_id, "quantity": 1 },
            //   dataType: 'json',
            //   success: function (data) {
            //     console.log('Success!', data);

            //     // Manually update the cart elements on the page
            //     updateCartElements();
            //   },
            //   error: function (err) {
            //     console.log('Error!', err);
            //   }
            // };

            // $.ajax(params);

            // console.log('Adding free Body Shaping sample which will be free after the discount is applied at checkout');

            // // Function to manually update the cart elements on the page
            // function updateCartElements() {
            //   // Fetch the updated cart data using another AJAX request
            //   $.ajax({
            //     type: 'GET',
            //     url: '/cart.js',
            //     dataType: 'json',
            //     success: function (cartData) {
            //       // Implement the logic to update the cart elements on the page dynamically
            //       // For example, you can use jQuery to update the cart count or display a message
            //       console.log('Cart updated dynamically', cartData);
            //     },
            //     error: function (err) {
            //       console.log('Error fetching cart data!', err);
            //     }
            //   });
            // }
          }


        }


      } else {

        console.log('User has declined the promo');

      }

      // run additional promo code here //

      resolve(true);


    }, 'text').done(function () { console.log('done!'); }).fail(function (request, error) { console.log('failed!', error); });


  });

  /*
  var feed_url = '/cart.js' ; 
  //if ( LOG_DESIGNS ) console.log( 'feed_url: ' + feed_url  ) ;
  console.log( 'loading cart...' ) ;
  // + '?cb=' + Math.random()
  $.get( feed_url , function( data ) {

    console.log( 'cart.js data: ' , data ) ;

  }).fail(function() {

    console.log( 'Failed to load cart data' ) ;
//  hideCartLoadingSpinner() ;

  });
  */
}
















// find and replace a h1 tag with an h2 tag so we don't end up with multiple 
function convertH1ToH2(str) {
  // check we have a start and end string //
  if (str.indexOf("<h1") >= 0 && str.indexOf("</h1") >= 0) {
    str = str.split('<h1').join('<h2');
    str = str.split('</h1').join('</h2');
    console.log('found and replaced the h1 tag', str);
  } else {
    if (str.indexOf("<h1") >= 0) {
      console.log('Found the H1 start tag but not the end tag');
    } else if (str.indexOf("</h1") >= 0) {
      console.log('Found the H1 end tag but not the start tag');
    } else {
      console.log('didnt find either the start or end h1 tags');
    }
  }

  return str;
}





function handleCartUpdated() {

  console.log('==========================================');
  console.log('handleCartUpdated');
  console.log('==========================================');


  console.log('Updated cart, so updating bold bundles.');

  //var event = new CustomEvent(  , { detail: {} } ) ;  
  //designs_base_url + 'u=' + query_obj.email
  var feed_url = '/cart';

  showCartLoadingSpinner();

  //updateForBuyXGetYPromotion() ;

  //if ( LOG_DESIGNS ) console.log( 'feed_url: ' + feed_url  ) ;
  $.get(feed_url + '?cb=' + Math.random(), function (data) {

    //Browser Sync
    var body_tag = '';
    if (data.indexOf("not-wholesaler") > 0) {
      body_tag = '<div ' + data.split('<body class="template-cart not-wholesaler"')[1].split('</body>')[0] + '</div>';
    } else {
      body_tag = '<div ' + data.split('<body class="template-cart is-wholesaler"')[1].split('</body>')[0] + '</div>';
    }
    console.log('body_tag:', body_tag);

    // convert the h1 tag of the loaded content into an h2 to prevent multiple h1s on the page //
    body_tag = convertH1ToH2(body_tag);


    var shopify_cart_template = $(body_tag).find('#shopify-section-cart-template');
    console.log('shopify_cart_template:', shopify_cart_template);

    //shopify-section-cart-template
    var cart_form = $(body_tag).find('#cart-form');
    console.log('cart_form:', cart_form);

    var cart_template = $(body_tag).find('#shopify-section-cart-template');
    console.log('cart_template:', cart_template);


    if (cart_form.length > 0) {
      var document_cart_form = document.getElementById('cart-form')
      if (document_cart_form) {
        if (document_cart_form.innerHTML) document_cart_form.innerHTML = $(cart_form).html();
        $("input[name='updates[]']").on('input', function () {
          $('.update-shopping-cart.btn--secondary.update-cart').trigger("click");
          //document.querySelector('.update-shopping-cart.btn--secondary.update-cart').trigger( "click" );
          //console.log("Quatity changed!");
        });
      } else {
        document.querySelector('#cart-reveal #shopify-section-cart-template').innerHTML = $(cart_template).html();
        $("input[name='updates[]']").on('input', function () {
          $('.update-shopping-cart.btn--secondary.update-cart').trigger("click");
          //document.querySelector('.update-shopping-cart.btn--secondary.update-cart').trigger( "click" );
          //console.log("Quatity changed!");
        });
      }
      //$( body_tag ).find( '.page-width.cart' ) 
    } else {
      //var page_width_cart = $( body_tag ).find( '.page-width.cart' ) 
      //console.log( 'page_width_cart: ' , cart_template ) ;
      $("input[name='updates[]']").on('input', function () {
        $('.update-shopping-cart.btn--secondary.update-cart').trigger("click");
        //document.querySelector('.update-shopping-cart.btn--secondary.update-cart').trigger( "click" );
        //console.log("Quatity changed!");
      });
      document.querySelector('#cart-reveal #shopify-section-cart-template').innerHTML = $(cart_template).html();
    }


    if (LOGGING) {
      console.log('success:', data);
      console.log('success! updating cart preview');
    }

    // add the + / - buttons
    $('.cart__quantity').each(function (i, el) {
      new QtySelector($(el));
    });

    addClickListenersToCartChangingLinks();

    // if the cart is empty, there won't be a #cart-form to find and replace //
    // page-width cart //
    var cart_is_empty = false;
    if ($(body_tag).find('.page-empty').length > 0) cart_is_empty = true;
    //console.log( 'cart_is_empty: ' , cart_is_empty ) ;
    if (cart_is_empty) {
      //console.log( 'hide the cart indicator' ) ;
      jQuery('.site-header__cart-indicator').addClass('hide');
    }

    hideCartLoadingSpinner();

    //runHardCodedPromotions() ;
    //updatePromosAfterCartUpdate() ;

    updateCartTotalAfterUpdate();


  }).fail(function () {

    console.log('handleCartUpdated > failed');
    //var event = new CustomEvent( USER_SAVES_FAILED , { detail: { designs: undefined , query: query_obj } } ) ;
    //window.dispatchEvent( event ) ;

    hideCartLoadingSpinner();


    //updatePromosAfterCartUpdate() ;

  });


  /*jQuery.getJSON( '/cart.js' , function( cart ) {

   // now have access to Shopify cart object
   console.log('There are now ' , cart );
   for ( var item in cart.items ) console.log( cart.items[ item ] ) ;

  });*/

}









// the slide-out cart pricing wasn't updating properly after items were added //
// this function resolves that issue 

function updateCartTotalAfterUpdate() {
  console.log('updateCartTotalAfterUpdate');
  $.ajax({
    url: '/cart.js',
    success: function (data) {
      //console.log( JSON.parse( data ).total_price / 100 ) ;
      //var old_cart_doctor_cart = window.BOLDCURRENCY.cartDoctor.cart;
      //window.BOLDCURRENCY.cartDoctor.cart = JSON.parse(data);
      //window.BOLDCURRENCY.converter.refresh('cart__subtotal');
      //window.BOLDCURRENCY.cartDoctor.cart = old_cart_doctor_cart ; 

    },
    dataType: 'text'
  });
}
















function updatePromosAfterCartUpdate() {

  return new Promise(function (resolve, reject) {

    $.get('/cart.js', function (data) {
      var body_shaping_sample_tally = 0;

      data = JSON.parse(data);
      console.log("Load was performed.", data);

      for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].variant_id == body_shaping_sample_id) {
          console.log('body shaping sample found at ' + i,);
          body_shaping_sample_tally++;
        }

        // add in additional promo checks here //
      }

      console.log('body_shaping_sample_tally: ', body_shaping_sample_tally);

      var promo_declined = signifiGetCookie("body_shaping_book_promo_declined");
      if (promo_declined == "true") console.log('The body shaping book promo has been declined');

      // only proceed if the promo has not been previously declined //
      if (promo_declined != "true") {

        var add_promo_item = false;
        var minimum_buy_quantity_for_promo_to_kick_in = 1;
        var promo_item_already_in_cart = false;

        // loop through the items in the cart, checking to see if any match the ids of the variants of the items applicable to the discount //
        var items_in_cart_which_match_promo_items = 0;
        for (var i = 0; i < data.items.length; i++) {

          var curr_id = data.items[i].variant_id;
          for (var j = 0; j < body_shaping_sample_standard_variant_id.length; j++) {

            var curr_discount_item = body_shaping_sample_standard_variant_id[j];
            // increase matching items if this id matches, and increase the total by the quantity of items in this line item //
            if (curr_id == curr_discount_item) items_in_cart_which_match_promo_items += data.items[i].quantity;
          }

          if (data.items[i].variant_id == body_shaping_book_id) {
            console.log('body shaping book found at ' + i);
            body_shaping_sample_tally++;
          }

          // add in additional promo checks here //
        }

        if (body_shaping_sample_tally > 0) promo_item_already_in_cart = true;
        console.log('promo reward is already in cart?  223', promo_item_already_in_cart);

        if (items_in_cart_which_match_promo_items >= minimum_buy_quantity_for_promo_to_kick_in && promo_item_already_in_cart == false) add_promo_item = true;
        if (items_in_cart_which_match_promo_items && promo_item_already_in_cart == false) add_promo_item = true;
        console.log('items_in_cart_which_match_promo_items ', items_in_cart_which_match_promo_items);
        console.log('add_promo_item ', add_promo_item);

        if (add_promo_item != true) {
          console.log('promo requirements met');
          console.log('Adding free Body Shaping Book which will be free after discount is applied at checkout');
          //console.log( 'Adding chai latte which will be free after discount is applied at checkout' ) ;
          // add the free milk nut bag //
          var params = {
            type: 'POST',
            url: '/cart/add.js',
            //data: {"id": chai_id , "quantity": 1 } ,
            data: { "id": body_shaping_sample_id, "quantity": 1 },
            dataType: 'json',
            success: function (data) { console.log('Success!', data); },
            error: function (err) { console.log('error!', err); }
          };
          $.ajax(params);
        }

      } else {
        console.log('User has declined the promo');
      }

      // run additional promo code here //
      resolve(true);
    }, 'text').done(function () { console.log('done!'); }).fail(function (request, error) { console.log('failed!', error); });
  });

}

















function addClickListenersToCartChangingLinks() {
  //console.log( 'addClickListenersToCartChangingLinks...' ) ;
  jQuery('#cart-reveal a[href^="/cart/change"] ').click(function (e) {
    e.preventDefault();
    //console.log( 'change link called' , e.target.href ) ;
    handleCartChangeRequest(e.target.href);
  });

  jQuery('a[href="/cart"].close-cart').click(function (e) {
    e.preventDefault();
    jQuery('#cart-reveal').removeClass('opened');
  });

  jQuery('script[src^="//d3k1w8lx8mqizo.cloudfront.net/lib/js/zm-widget-js/dist/zipmoney-widgets-v1.min.js"] ').each(function () {
    this.src = '//d3k1w8lx8mqizo.cloudfront.net/lib/js/zm-widget-js/dist/zipmoney-widgets-v1.min.js' + '?cb=' + Date.now();
  });



}















function signifi_update_afterpay() {

  //console.log( 'signifi_update_afterpay...' ) ;
  //jQuery( ".afterpay-paragraph" ).fadeTo( 'medium' , 0 ) ; //.fadeIn() ;

  afterpay_price_mutation_observer.disconnect();
  var newCurrency = BOLDCURRENCY.currentCurrency;
  if (newCurrency == "AUD") {
    updateAfterpayPricingDisplayDetails();
  } else {
    window.last_price = jQuery(".product-sale__price span.money").text();
    endAfterpayPricingUpdate();
    jQuery(".afterpay-paragraph").animate({ opacity: 0 }, function () { });
  }

}








function endAfterpayPricingUpdate() {

  //console.log( 'endAfterpayPricingUpdate...' ) ;
  queued_price_changes.pop();
  updateAfterpayWhenProductPriceChanges();

}



function updateAfterpayPricingDisplayDetails() {

  var newCurrency = BOLDCURRENCY.currentCurrency;
  var display_afterpay = false;

  if (newCurrency == "AUD") display_afterpay = true;

  //console.log( 'display_afterpay: ' , display_afterpay ) ;
  //if ( jQuery( ".product-sale__price span.money" ).length > 0) {
  var newPrice;
  if (jQuery(".product-sale__price span.money").text().indexOf("AUD" > 0)) {
    newPrice = jQuery(".product-sale__price span.money").text().replace(/[^0-9]/gi, "");
  } else {
    newPrice = jQuery(".product-sale__price span.money").attr("data-currency-aud").replace(/[^0-9]/gi, "");
  }
  //}

  var np = jQuery(".product-sale__price span.money").text();
  var prices_match = false;
  if (window.last_price) {
    //console.log( window.last_price + ' == ' + np )
    if (window.last_price == np) prices_match = true;
  }


  if (display_afterpay && !prices_match) {

    afterpay_current_variant.price = newPrice;
    window.afterpay_shop_currency = newCurrency;

    jQuery(".afterpay-paragraph").animate({ opacity: 0 }, function () {

      jQuery(".afterpay-paragraph").remove();
      Afterpay.initProductPage(jQuery);
      jQuery(".afterpay-paragraph").css('opacity', 0);
      revealAfterpayPricing(true);

    });

  } else {

    endAfterpayPricingUpdate();

  }

  window.last_price = np;
  window.afterpay_shop_currency = newCurrency;

}






function revealAfterpayPricing(bool) {

  _opacity = 1
  if (!bool) _opacity = 0
  //console.log( 'revealAfterpayPricing('+ bool +')' ) ;
  jQuery(".afterpay-paragraph").animate({ opacity: _opacity }, function () {
    //console.log( 'we have now updated the Afterpay pricing details' ) ;
    endAfterpayPricingUpdate();
  });


}









window.addEventListener('CART_UPDATED', handleCartUpdated);


















var queued_price_changes = [];



// deal with a queue of price change requests //
function respondToPriceChange() {

  //console.log( 'respondToPriceChange: ' , queued_price_changes.length ) ;
  if (queued_price_changes.length == 1) {

    //console.log( '>>>>>>>>>>>>> ACTUALLY respondToPriceChange: ' , queued_price_changes.length ) ;
    // if the afterpay paragraph exists, fade it out then update
    if (document.querySelector('.afterpay-paragraph')) signifi_update_afterpay();

  } else if (queued_price_changes.length > 1) {

    setTimeout(function () {

      //console.log('-');
      queued_price_changes.pop();
      if (queued_price_changes.length == 1) respondToPriceChange();

    }, 1000);

  }

}






var afterpay_price_mutation_observer;
var afterpay_price_mutation_observer_target;
var afterpay_price_mutation_observer_config = { characterData: true, attributes: false, childList: true, subtree: false };

// Callback function to execute when mutations are observed //
var AfterpayPriceMutationCallback = function (mutationsList, observer) {

  //console.log('+');
  queued_price_changes.push({});

  //console.log( 'Mutation registered...' ) ;
  respondToPriceChange();

};


// 
function updateAfterpayWhenProductPriceChanges() {
  //console.log( 'preventAfterpayFromDisplayNone' ) ;
  // Select the node that will be observed for mutations
  afterpay_price_mutation_observer_target = document.querySelector('.product-single__price .money');
  if (afterpay_price_mutation_observer_target) {
    // Create an observer instance linked to the callback function
    afterpay_price_mutation_observer = new MutationObserver(AfterpayPriceMutationCallback);
    // Start observing the target node for configured mutations
    afterpay_price_mutation_observer.observe(afterpay_price_mutation_observer_target, afterpay_price_mutation_observer_config);
  }
}



// listen for price changes //
setTimeout(function () {
  updateAfterpayWhenProductPriceChanges();
}, 5000);

// give it a run just to make sure //
setTimeout(function () {
  if (afterpay_price_mutation_observer_target) {
    queued_price_changes.push({});
    respondToPriceChange();
  }
}, 6000);












/////////////////////////////////////////////////////////////////////////////////
///////////////////////// continue shopping /////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////
var current_page = window.location.pathname;
var is_cart = false;
if (current_page == '/cart') is_cart = true;

document.body.onclick = function (e) {
  //console.log( 'clicked' ) ;
  if (e.target.classList) {

    //console.log( 'e.target.classList: ' , e.target.classList ) ;
    if (e.target.classList.contains('continue-shopping-btn')) {

      /*
      console.log( 'isWholesaleUser: ' + isWholesaleUser ) ;
      console.log( 'current_page: ' , current_page ) ;
      console.log( 'is_cart: ' , is_cart ) ;
      */

      e.preventDefault();
      //console.log( e , ' is a shopping button' ) ;
      if (is_cart) {
        // if we're already on the cart page, we should navigate the entire page to the continue_shopping_url  //
        //console.log( 'Clicked the continue shopping button!' ) ;
        window.location.pathname = continue_shopping_url;
      } else {
        // if we're NOT on the cart page, we should collapse the cart reveal //
        //console.log( 'NOT CART PAGE > Clicked the continue shopping button! > So HIDE ME!' ) ;
        var cart_reveal = document.querySelector('#cart-reveal');
        if (cart_reveal) cart_reveal.classList.remove('opened');
      }
    }
  }
}
/////////////////////////////////////////////////////////////////////////////////
//////////////////////// end continue shopping //////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////





// listen for removal of chais in case anyone doesn't want their free chai //
// if they remove it, we'll set a cookie so it's not added back to their cart //
window.enableDeclineChaiPromo = function () {
  console.log('enableDeclineChaiPromo');
  var remove_chai_links = jQuery(".remove-from-cart-link[data-variant-id='" + chai_id + "']");
  if (remove_chai_links.length > 0) {
    $(remove_chai_links).on('click', function () { window.declineChaiPromo() });
  }
}

window.declineChaiPromo = function () {
  console.log('declineChaiPromo!');
  window.signifiSetCookie("chai_promo_declined", "true", 100);
  //var cookieValue = document.cookie.replace( /(?:(?:^|.*;\s*)chai_promo_declined\s*\=\s*([^;]*).*$)|^.*$/, "$1" ) ;
  //alert('cookieValue:' + cookieValue ) ;
  console.log(signifiGetCookie("chai_promo_declined"));
}





// BODY SHAPING BOOK //
// listen for removal of Body Shaping Book in case anyone doesn't want their free Body Shaping Book //
// if they remove it, we'll set a cookie so it's not added back to their cart //
window.enableDeclineBodyShapingBookPromo = function () {
  console.log('enableDeclineBodyShapingBookPromo');
  var remove_body_shaping_book_links = jQuery(".remove-from-cart-link[data-variant-id='" + body_shaping_book_id + "']");
  if (remove_body_shaping_book_links.length > 0) {
    $(remove_body_shaping_book_links).on('click', function () { window.declineBodyShapingBookPromo() });
  }
}

window.declineBodyShapingBookPromo = function () {

  console.log('declineBodyShapingBookPromo!');
  window.signifiSetCookie("body_shaping_book_promo_declined", "true", 100);
  //var cookieValue = document.cookie.replace( /(?:(?:^|.*;\s*)chai_promo_declined\s*\=\s*([^;]*).*$)|^.*$/, "$1" ) ;
  //alert('cookieValue:' + cookieValue ) ;
  console.log(signifiGetCookie("body_shaping_book_promo_declined"));

}

window.enableDeclineBodyShapingSamplePromo = function () {
  console.log('enableDeclineBodyShapingSamplePromo');
  var remove_body_shaping_sample_links = jQuery(".remove-from-cart-link[data-variant-id='" + body_shaping_sample_id + "']");
  if (remove_body_shaping_sample_links.length > 0) {
    $(remove_body_shaping_sample_links).on('click', function () { window.declineBodyShapingSamplePromo() });
  }
}

window.declineBodyShapingSamplePromo = function () {

  console.log('declineBodyShapingSamplePromo!');
  window.signifiSetCookie("body_shaping_sample_promo_declined", "true", 100);
  //var cookieValue = document.cookie.replace( /(?:(?:^|.*;\s*)chai_promo_declined\s*\=\s*([^;]*).*$)|^.*$/, "$1" ) ;
  //alert('cookieValue:' + cookieValue ) ;
  console.log(signifiGetCookie("body_shaping_sample_promo_declined"));

}






// check through an array of items (ie we expect cart.items) for any item with a variant id that matches the book pre-order items' variant //
window.checkCartForBookPreOrderItem = function (cart_items) {
  var quantity = 0;
  for (var i = 0; i < cart_items.length; i++) {
    if (cart_items[i].variant_id == window.book_pre_order.variant) quantity = cart_items[i].quantity;
  }
  return quantity;
}









// clone and adapt enableDeclineChaiPromo and declineChaiPromo functions for each additional buyXgetY promo //





window.signifiSetCookie = function (name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}


window.signifiGetCookie = function (name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

if (body_shaping_sample_promo_is_active) {
  jQuery(document).ready(function () {
    // window.enableDeclineBodyShapingSamplePromo() ;
    console.log('give me something pls')
  });
}/**/


if (body_shaping_book_promo_is_active) {
  jQuery(document).ready(function () {
    window.enableDeclineBodyShapingBookPromo();
  });
}/**/

if (chai_promo_is_active) {
  jQuery(document).ready(function () {
    window.enableDeclineChaiPromo();
  });
}

jQuery(document).ready(function () {
  jQuery(function () {
    jQuery(window).scroll(function () {

      if (jQuery(this).scrollTop() > 50) {
        jQuery("body").addClass("sticky_header");
      } else {
        jQuery("body").removeClass("sticky_header");
      }
    });

  });
});

function show0(arg, div) {
  jQuery("#footer-0").slideToggle(500);
  jQuery(".ftr_menu_btn0").toggleClass("open");

}
function show1(arg, div) {
  jQuery("#footer-1").slideToggle(500);
  jQuery(".ftr_menu_btn1").toggleClass("open");

}
function show2(arg, div) {
  jQuery("#footer-2").slideToggle(500);
  jQuery(".ftr_menu_btn2").toggleClass("open");

}
function show3(arg, div) {
  jQuery("#footer-3").slideToggle(500);
  jQuery(".ftr_menu_btn3").toggleClass("open");
}
function show4(arg, div) {
  jQuery("#footer-4").slideToggle(500);
  jQuery(".ftr_menu_btn4").toggleClass("open");
}
function showpd(arg, div) {
  jQuery(".prod-des-section-content").slideToggle(500);
  jQuery(".prod-des-section-title").toggleClass("open");
}

$('.logo-slider').slick({
  speed: 300,
  slidesToShow: 6,
  slidesToScroll: 1,
  autoplay: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1

      }
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});